<template>
  <div class="toolbar">
    <!-- 管线工具 -->
    <div class="dropdown-container">
      <a-button @click="toggleDropdown('pipelineTools')">
        管线工具
        <a-icon type="down" />
      </a-button>
      <div class="dropdown-menu" v-show="activeDropdown === 'pipelineTools'">
        <div class="dropdown-item" @click="showExportDialog">数据导出</div>
        <div class="dropdown-item" @click="handlePipelineTool('batchEdit')">批量修改</div>
        <div class="dropdown-item" @click="showDataCheckDialog">数据查错</div>
        <div class="dropdown-item" @click="handlePipelineTool('statistics')">信息统计</div>
        <div class="dropdown-item" @click="handlePipelineTool('insertProject')">插入项目</div>
      </div>
    </div>

    <!-- 辅助工具 -->
    <div class="dropdown-container">
      <a-button @click="toggleDropdown('assistTools')">
        辅助工具
        <a-icon type="down" />
      </a-button>
      <div class="dropdown-menu" v-show="activeDropdown === 'assistTools'" style="width: 140px;">
        <div class="dropdown-item" @click="handleAssistTool('createSelection')">创建管线选择集</div>
        <div class="dropdown-item" @click="handleAssistTool('pointMark')">点号下划线标注</div>
        <div class="dropdown-item" @click="handleAssistTool('heightMark')">点高程下划线标注</div>
      </div>
    </div>


    <!-- <a-button @click="handleLayer">图层管理</a-button> -->

    <!-- 查看图层 -->
    <div class="dropdown-container">
      <a-button @click="toggleDropdown('viewLayers')">
        查看图层
        <a-icon type="down" />
      </a-button>
      <div class="dropdown-menu" style="width: 300px;" v-show="activeDropdown === 'viewLayers'">
        <a-layout style="height: 150px">
          <a-layout-sider v-model="collapsed" :trigger="null" collapsible
            style="flex: 0 0 116px; min-width: 0px !important; width: 116px; background-color: white">
            <!-- 修复后的菜单 -->
            <a-menu style="width: 116px" :selectedKeys="selectedKeys" @select="handleLayerSelect" mode="inline">

              <a-menu-item v-for="item in primitivehandleLayerData" :key="item.key">
                <span>{{ item.title }}</span>
              </a-menu-item>
            </a-menu>
          </a-layout-sider>
          <a-layout>
            <a-layout-content style="background-color: white;">
              <!-- 右侧内容区域 -->
              <template v-for="(item, index) in handleLayerDataList">
                <div class="layout-content-div" :key="index">
                  {{ item.title }}

                  <span class="icon-wrapper" @click.stop="showLayerType(item)">
                    <a-icon class="show-icon" type="eye" v-if="item.show" style="color: #63e973;" />
                    <a-icon class="show-icon" type="eye-invisible" v-else />
                  </span>
                </div>
              </template>
            </a-layout-content>
          </a-layout>
        </a-layout>
      </div>
    </div>

    <!-- 底图选择 -->
    <div class="dropdown-container">
      <a-button @click="toggleDropdown('baseMaps')">
        {{ currentBaseMap }}
        <a-icon type="down" />
      </a-button>
      <div class="dropdown-menu" v-show="activeDropdown === 'baseMaps'">
        <div class="dropdown-item" @click="handleBaseMapChange('vector')">矢量地图</div>
        <div class="dropdown-item" @click="handleBaseMapChange('Satellite')">天地影像</div>
      </div>
    </div>


    <a-button @click="itemSelection" style="margin-right: 10px;">项目选择</a-button>

    <a-button @click="handleImportGIS">一键导入管理GIS系统</a-button>

    <!--导出弹窗-->
    <a-modal title="数据导出" :visible="exportDialogVisible" @ok="handleExport" @cancel="exportDialogVisible = false"
      :confirmLoading="exportLoading" :getContainer="getContainer" :centered="true" wrapClassName="export-modal">
      <a-form :form="exportForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-item label="导出类型">
          <a-select v-model="deriveType">
            <a-select-option value="excel">
              导出点线表（Excel表格）
            </a-select-option>
            <a-select-option value="cad">
              导出DXF文件
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="模板选择" v-if="deriveType == 'excel'">
          <a-select v-decorator="['templateId', { rules: [{ required: true, message: '请选择模板' }] }]"
            placeholder="请选择导出模板" @change="handleTemplateChange"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode">
            <a-select-option v-for="item in templateList" :key="item.id" :value="item.id">
              {{ item.templateName }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- 数据查错对话框 -->
    <a-modal title="数据查错" :visible="dataCheckDialogVisible" @ok="handleDataCheck"
      @cancel="dataCheckDialogVisible = false" :confirmLoading="dataCheckLoading" width="480px" centered
      class="data-check-modal" :getContainer="getContainer">
      <!-- <div class="check-section">
        <div class="section-title">
          <div class="title-bar"></div>
          <span>查错范围</span>
        </div>
        <div class="section-content">
          <a-radio-group v-model="dataCheckForm.errorCheckRange" class="horizontal-radio">
            <a-radio :value="1">整个图形</a-radio>
            <a-radio :value="2">框选范围</a-radio>
          </a-radio-group>
        </div>
      </div> -->

      <div class="check-section" style="display: flex;">
        <div class="section-title">
          <div class="title-bar"></div>
          <span>查错条件：</span>
        </div>
        <div class="section-content">
          <a-checkbox-group v-model="dataCheckForm.errorCheckConditions" class="horizontal-checkbox">
            <a-checkbox :value="1">点表</a-checkbox>
            <a-checkbox :value="2">线表</a-checkbox>
          </a-checkbox-group>
        </div>
      </div>
    </a-modal>

    <!-- 创建管线选择集弹窗 -->
    <a-modal :title="tubesOrLines == 2 ? '管线过滤' : '管点过滤'" :visible="selectionDialogVisible" @ok="handleSelectionSubmit"
      @cancel="handleSelectionCancel" :confirmLoading="selectionLoading" :getContainer="getContainer" :centered="true"
      :width="680" wrapClassName="selection-modal">
      <div class="filter-container">
        <a-form :form="selectionForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
          <!-- 特征过滤部分 -->
          <div class="filter-section">
            <div class="section-title">特征过滤</div>
            <div class="section-content">
              <a-row :gutter="24" type="flex" align="middle">
                <a-col :span="14">
                  <a-form-item label="特征类型" style="display: flex;align-items: center;">
                    <a-radio-group v-model="tubesOrLines" @change="handleFeatureChange">
                      <a-radio :value="1">管点</a-radio>
                      <a-radio :value="2">管线</a-radio>
                    </a-radio-group>
                  </a-form-item>
                </a-col>
                <a-col :span="10" v-if="tubesOrLines == 1">
                  <a-form-item label="连通数" style="display: flex;align-items: center;">
                    <a-input-number v-model="connectivityNumber" :min="0" style="width: 100%" placeholder="请输入连通数" />
                  </a-form-item>
                </a-col>
              </a-row>
            </div>
          </div>

          <!-- 过滤条件部分 -->
          <div class="filter-section">
            <div class="section-title">过滤条件</div>
            <div class="section-content">
              <div v-for="(item, i) in filtrationConditions" :key="i" class="condition-item">
                <a-row :gutter="24" type="flex" align="middle">
                  <a-col :span="10">
                    <a-form-item label="字段名" style="display: flex;align-items: center;">
                      <a-select v-model="item.label" placeholder="请选择字段" style="width: 100%"
                        @change="updatefiltrationList(item, i)"
                        :getPopupContainer="(triggerNode) => triggerNode.parentNode">
                        <a-select-option v-for="(fult, index) in fFiltrationList()" :key="index" :value="fult.label">
                          {{ fult.label }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="11">
                    <a-form-item label="字段值" style="display: flex;align-items: center;">
                      <div class="filter-container-zd">
                        <div class="filter-item">
                          <template v-if="item.type">
                            <!-- 选择下拉框 -->
                            <template v-if="item.type == 'select'">
                              <a-select v-if="!item.editor.flag" v-model="item.condition" style="width: 100%"
                                :placeholder="'请选择' + item.label" :disabled="batchEditStep === 2"
                                :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                @change="() => handleConditionChange(item, i)">
                                <a-select-option v-for="(value, key) in item.list" :key="key" :value="value">
                                  {{ value }}
                                </a-select-option>
                              </a-select>
                              <!-- 切换输入模式 -->

                              <a-input v-else v-model="item.condition" :placeholder="'请输入' + item.label" allowClear
                                :disabled="batchEditStep === 2" @change="() => handleConditionChange(item, i)" />

                              <!-- 切换输入框按键 -->
                              <div v-if="item.editor != false" style="display: inline-block; margin-left: 12px">
                                <a-icon type="retweet" @click="toggleModule(item)" />
                              </div>
                            </template>

                            <!-- 树型下拉框 -->
                            <template v-else-if="item.type == 'options'">
                              <!-- 默认样式 -->

                              <a-cascader v-if="!item.editor.flag" v-model="item.condition" :options="item.options"
                                :display-render="displayRender" expand-trigger="hover" :placeholder="'请选择' + item.label"
                                :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                :disabled="batchEditStep === 2" @change="() => handleConditionChange(item, i)" />

                              <!-- 切换输入模式 -->

                              <a-input v-else v-model="item.condition" :placeholder="'请输入' + item.label" allowClear
                                :disabled="batchEditStep === 2" @change="() => handleConditionChange(item, i)" />

                              <!-- 切换输入框按键 -->
                              <div v-if="item.editor != false" style="display: inline-block; margin-left: 12px">
                                <a-icon type="retweet" @click="toggleModule(item)" />
                              </div>
                            </template>

                            <!-- 文本框 -->
                            <template v-else-if="item.type == 'input'">

                              <a-input v-model="item.condition" :placeholder="'请输入' + item.label"
                                :disabled="batchEditStep === 2" @change="() => handleConditionChange(item, i)" />
                            </template>
                          </template>
                          <!-- 不可输入提示文本框 -->
                          <template v-else>
                            <a-input disabled placeholder="请选择字段值" />
                          </template>
                        </div>
                        <div class="action-buttons">
                          <img v-if="i === 0" src="@/assets/partition/differentRules/add.png" class="action-icon"
                            @click="addFilterConditions" />
                          <img v-else src="@/assets/partition/differentRules/minus.png" class="action-icon"
                            @click="removeFilterConditions(i)" />
                        </div>

                      </div>

                    </a-form-item>

                  </a-col>

                </a-row>
              </div>

              <!-- 添加条件关系选择 -->
              <div style="text-align: center;">
                <a-radio-group v-model="andWithOr">
                  <a-radio :value="1">和</a-radio>
                  <a-radio :value="2">或</a-radio>
                </a-radio-group>
              </div>
            </div>
          </div>
        </a-form>
      </div>
    </a-modal>

    <!-- 批量修改弹窗 -->
    <a-modal :title="tubesOrLines == 2 ? '管线批量修改' : '管点批量修改'" :visible="batchEditVisible" @ok="handleBatchEditSubmit"
      @cancel="handleBatchEditCancel" :confirmLoading="batchEditLoading" :getContainer="getContainer" :centered="true"
      :width="700" wrapClassName="batch-edit-modal">

      <!-- 步骤指示器 -->
      <div class="batch-edit-steps">
        <div class="step-item" :class="{ active: batchEditStep === 1 }">
          <div class="step-number">1</div>
          <div class="step-title">设置过滤条件</div>
        </div>
        <div class="step-line" :class="{ active: batchEditStep === 2 }"></div>
        <div class="step-item" :class="{ active: batchEditStep === 2 }">
          <div class="step-number">2</div>
          <div class="step-title">批量修改内容</div>
        </div>
      </div>

      <!-- 第一步：过滤条件 -->
      <div v-if="batchEditStep === 1" class="filter-container" :class="{ 'filter-disabled': batchEditStep === 2 }">
        <a-form :form="selectionForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"
          :disabled="batchEditStep === 2">
          <!-- 特征过滤部分 -->
          <div class="filter-section">
            <div class="section-title">特征过滤</div>
            <div class="section-content">
              <a-row :gutter="24" type="flex" align="middle">
                <a-col :span="14">
                  <a-form-item label="特征类型" style="display: flex;align-items: center;">
                    <a-radio-group v-model="tubesOrLines" @change="handleFeatureChange" :disabled="batchEditStep === 2">
                      <a-radio :value="1">管点</a-radio>
                      <a-radio :value="2">管线</a-radio>
                    </a-radio-group>
                  </a-form-item>
                </a-col>
                <a-col :span="10" v-if="tubesOrLines == 1">
                  <a-form-item label="连通数" style="display: flex;align-items: center;">
                    <a-input-number v-model="connectivityNumber" :min="0" style="width: 100%" placeholder="请输入连通数"
                      :disabled="batchEditStep === 2" />
                  </a-form-item>
                </a-col>
              </a-row>
            </div>
          </div>

          <!-- 过滤条件部分 -->
          <div class="filter-section">
            <div class="section-title">
              <span>过滤条件</span>
              <a-tooltip v-if="filtrationConditions.filter(f => f.label).length > 0">
                <template slot="title">满足条件的数据将进行批量修改</template>
                <a-icon type="info-circle" style="margin-left: 8px; color: #1890ff;" />
              </a-tooltip>
            </div>
            <div class="section-content">
              <div v-for="(item, i) in filtrationConditions" :key="i" class="condition-item">
                <a-row :gutter="24" type="flex" align="middle">
                  <a-col :span="10">
                    <a-form-item label="字段名" class=" required" style="display: flex;align-items: center;">
                      <a-select v-model="item.label" placeholder="请选择字段" style="width: 100%"
                        @change="updatefiltrationList(item, i)" :disabled="batchEditStep === 2"
                        :getPopupContainer="(triggerNode) => triggerNode.parentNode">
                        <a-select-option v-for="(fult, index) in fFiltrationList()" :key="index" :value="fult.label">
                          {{ fult.label }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="11">
                    <a-form-item label="字段值" class=" required" style="display: flex;align-items: center;">
                      <div class="field-value-wrapper">
                        <div class="field-input">
                          <template v-if="item.type">
                            <!-- 选择下拉框 -->
                            <template v-if="item.type == 'select'">
                              <a-select v-if="!item.editor.flag" v-model="item.condition" style="width: 100%"
                                :placeholder="'请选择' + item.label" :disabled="batchEditStep === 2"
                                :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                @change="() => handleConditionChange(item, i)">
                                <a-select-option v-for="(value, key) in item.list" :key="key" :value="value">
                                  {{ value }}
                                </a-select-option>
                              </a-select>
                              <!-- 切换输入模式 -->

                              <a-input v-else v-model="item.condition" :placeholder="'请输入' + item.label" allowClear
                                :disabled="batchEditStep === 2" @change="() => handleConditionChange(item, i)" />

                              <!-- 切换输入框按键 -->
                              <div v-if="item.editor != false" style="display: inline-block; margin-left: 12px">
                                <a-icon type="retweet" @click="toggleModule(item)" />
                              </div>
                            </template>

                            <!-- 树型下拉框 -->
                            <template v-else-if="item.type == 'options'">
                              <!-- 默认样式 -->

                              <a-cascader v-if="!item.editor.flag" v-model="item.condition" :options="item.options"
                                :display-render="displayRender" expand-trigger="hover" :placeholder="'请选择' + item.label"
                                :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                :disabled="batchEditStep === 2" @change="() => handleConditionChange(item, i)" />

                              <!-- 切换输入模式 -->

                              <a-input v-else v-model="item.condition" :placeholder="'请输入' + item.label" allowClear
                                :disabled="batchEditStep === 2" @change="() => handleConditionChange(item, i)" />

                              <!-- 切换输入框按键 -->
                              <div v-if="item.editor != false" style="display: inline-block; margin-left: 12px">
                                <a-icon type="retweet" @click="toggleModule(item)" />
                              </div>
                            </template>

                            <!-- 文本框 -->
                            <template v-else-if="item.type == 'input'">

                              <a-input v-model="item.condition" :placeholder="'请输入' + item.label"
                                :disabled="batchEditStep === 2" @change="() => handleConditionChange(item, i)" />
                            </template>
                          </template>
                          <!-- 不可输入提示文本框 -->
                          <template v-else>
                            <a-input disabled placeholder="请选择字段值" />
                          </template>
                        </div>
                        <div class="field-action">
                          <a-button v-if="i === 0" type="link" class="action-btn add-btn"
                            :disabled="batchEditStep === 2 || filtrationConditions.length >= 3"
                            @click="addFilterConditions">
                            <img src="@/assets/partition/differentRules/add.png" alt="添加" />
                          </a-button>
                          <a-button v-else type="link" class="action-btn remove-btn" :disabled="batchEditStep === 2"
                            @click="() => removeFilterConditions(i)">
                            <img src="@/assets/partition/differentRules/minus.png" alt="删除" />
                          </a-button>
                        </div>
                      </div>
                    </a-form-item>
                  </a-col>
                </a-row>
              </div>

              <!-- 添加条件关系选择 -->
              <div style="text-align: center;">
                <a-radio-group v-model="andWithOr" :disabled="batchEditStep === 2" buttonStyle="solid">
                  <a-radio-button :value="1">和</a-radio-button>
                  <a-radio-button :value="2">或</a-radio-button>
                </a-radio-group>
              </div>
            </div>
          </div>
        </a-form>
      </div>

      <!-- 第二步：批量修改内容 -->
      <div v-if="showBatchEditFields" class="batch-edit-container">
        <div class="filter-summary">
          <div class="summary-item">
            <span class="summary-label">过滤结果：</span>
            <span class="summary-value highlight">{{ filterResultCount }} 条数据</span>
          </div>
          <div class="summary-item">
            <span class="summary-label">过滤条件：</span>
            <span class="summary-value">{{ filterConditionSummary }}</span>
          </div>
        </div>
        <div class="batch-edit-fields">
          <div v-for="(item, index) in batchEditFields" :key="index">
            <a-row :gutter="24" type="flex" align="middle" class="edit-row">
              <a-col :span="7">
                <a-form-item label="字段名" class="compact-form-item required">
                  <a-select style="width: 100%" v-model="item.fieldName" placeholder="请选择要修改的字段"
                    @change="(value) => handleField2Change(value, index)"
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode">
                    <a-select-option v-for="field in getAvailableFields(index)" :key="field.label" :value="field.label">
                      {{ field.label }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="原始值" class="compact-form-item">
                  <a-input :value="item.originalValue" disabled />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="修改值" class="compact-form-item">
                  <div class="filter-item" style="display: flex;align-items: center;">
                    <template v-if="item.fieldName">
                      <template v-if="getFieldType(item.fieldName) === 'select'">
                        <a-select v-if="!item.editMode.flag" v-model="item.newValue" style="width: 100%"
                          :placeholder="'请选择' + item.fieldName"
                          :getPopupContainer="(triggerNode) => triggerNode.parentNode">
                          <a-select-option v-for="value in getFieldValues(item.fieldName)" :key="value" :value="value">
                            {{ value }}
                          </a-select-option>
                        </a-select>
                        <a-input v-else v-model="item.newValue" :placeholder="'请输入' + item.fieldName" allowClear />

                        <div v-if="getFieldEditor(item.fieldName)" style="display: inline-block; margin-left: 12px">
                          <a-icon type="retweet" @click="toggleEditMode(index)" style="cursor: pointer;" />
                        </div>

                      </template>
                      <template v-else-if="getFieldType(item.fieldName) === 'options'">
                        <a-cascader v-if="!item.editMode.flag" v-model="item.newValue"
                          :options="getFieldOptions(item.fieldName)" :display-render="displayRender"
                          expand-trigger="hover" :placeholder="'请选择' + item.fieldName" style="width: 100%" />
                        <a-input v-else v-model="item.newValue" :placeholder="'请输入' + item.fieldName" allowClear />

                        <div v-if="getFieldEditor(item.fieldName)" style="display: inline-block; margin-left: 12px; ">
                          <a-icon type="retweet" @click="toggleEditMode(index)" style="cursor: pointer;" />
                        </div>


                      </template>
                      <template v-else>
                        <a-input v-model="item.newValue" :placeholder="'请输入' + item.fieldName" />
                      </template>
                    </template>
                    <a-input v-else disabled placeholder="请先选择字段" />
                  </div>
                </a-form-item>
              </a-col>
              <a-col :span="3" class="action-buttons"
                style="margin-top: 13px;display: flex;    justify-content: flex-end;">
                <img v-if="index === batchEditFields.length - 1" src="@/assets/partition/differentRules/add.png"
                  class="action-icon add-btn" @click="addBatchEditField" alt="添加" title="添加" />
                <img v-if="batchEditFields.length > 1" src="@/assets/partition/differentRules/minus.png"
                  class="action-icon remove-btn" @click="removeBatchEditField(index)" alt="删除" title="删除" />
              </a-col>
            </a-row>
          </div>
        </div>
      </div>

      <template slot="footer">
        <div class="modal-footer">
          <a-button @click="handleBatchEditCancel">取 消</a-button>
          <a-button v-if="batchEditStep === 2" @click="handlePrevStep">上一步</a-button>
          <a-button type="primary" :loading="batchEditLoading" @click="handleBatchEditSubmit">
            {{ batchEditStep === 1 ? '下一步' : '确 定' }}
          </a-button>
        </div>
      </template>
    </a-modal>

    <!-- 信息统计弹窗 -->
    <a-modal title="信息统计" :visible="statisticsVisible" @cancel="statisticsVisible = false" :footer="null"
      :centered="true" :width="680" :getContainer="getContainer" wrapClassName="statistics-modal">
      <div class="statistics-container">
        <div class="statistics-header">
          <a-switch v-model="showEcharts" checked-children="图表" un-checked-children="列表" class="view-switch" />
        </div>

        <div v-if="submitting" class="statistics-loading">
          <a-spin tip="加载中..."></a-spin>
        </div>

        <div v-else class="statistics-content">
          <!-- ECharts 图表视图 -->
          <div v-if="showEcharts" class="charts-container">
            <div ref="pointsChart" class="statistics-chart"></div>
            <div ref="linesChart" class="statistics-chart"></div>
          </div>

          <!-- 列表视图 -->
          <template v-else>
            <template v-if="statisticsData && statisticsData.length > 0">
              <div v-for="(item, index) in statisticsData" :key="index" class="statistics-section">
                <div class="section-header">
                  <span class="section-title">{{ item.tubeClassName || '--' }}</span>
                </div>
                <div class="section-body">
                  <div class="statistics-grid">
                    <div class="grid-item">
                      <div class="item-label">明显点</div>
                      <div class="item-value">{{ formatNumber(item.informationStatisticsResult.salientPoints || 0) }}个
                      </div>
                    </div>
                    <div class="grid-item">
                      <div class="item-label">隐藏点</div>
                      <div class="item-value">{{ formatNumber(item.informationStatisticsResult.hiddenPoint || 0) }}个
                      </div>
                    </div>
                    <div class="grid-item">
                      <div class="item-label">点总数</div>
                      <div class="item-value">{{ formatNumber(item.informationStatisticsResult.totalNumberOfPoints || 0)
                      }}个</div>
                    </div>
                    <div class="grid-item">
                      <div class="item-label">管线总数</div>
                      <div class="item-value">{{ formatNumber(item.informationStatisticsResult.totalNumberOfLines || 0)
                      }}条</div>
                    </div>
                    <div class="grid-item">
                      <div class="item-label">管网长度</div>
                      <div class="item-value">{{ formatNumber(item.informationStatisticsResult.pipelineLength || 0) }}m
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div v-else class="empty-data">
              <a-empty description="暂无统计数据" />
            </div>
          </template>
        </div>
      </div>
    </a-modal>

    <!-- 数据查错详细列表弹窗 -->
    <a-drawer title="数据查错详细列表" placement="right" :width="600" :visible="showErrorDetailDialog"
      @close="handleErrorDetailClose" :bodyStyle="{ padding: '0 24px 24px' }" :mask="false" :maskClosable="false"
      :destroyOnClose="true" :getContainer="getContainer">
      <a-tabs default-active-key="1" v-model="tabsType">
        <a-tab-pane key="1" tab="管点表">
          <!-- 刷新按钮 -->
          <div class="refresh-button-container">
            <a-button type="primary" icon="sync" @click="refreshErrorDetailData">刷新</a-button>
          </div>
          <!-- 自定义的标签切换 -->
          <div class="custom-tabs">
            <div class="tab-header">
              <div v-for="(tab, index) in pointErrorTabs" :key="index"
                :class="['tab-item', currentPointTab === index ? 'active' : '']" @click="currentPointTab = index">
                <span class="tab-text">{{ tab.title }}</span>
                <span class="tab-badge">{{ pointErrorLists[tab.key].length }}</span>
              </div>
            </div>

            <div class="tab-content">
              <!-- 孤立点列表 -->
              <div v-show="currentPointTab === 0" class="error-section">
                <a-table :columns="pointColumns" :data-source="pointErrorLists.isolationPointList"
                  :pagination="getPointPagination('isolationPointList')"
                  @change="(pagination) => handlePointTableChange(pagination, 'isolationPointList')" size="middle"
                  bordered :rowKey="(record, index) => record.id + index"
                  :row-class-name="(record) => record.id === currentViewDetailId ? 'highlight-row' : ''"
                  :scroll="{ y: 580 }">
                  <template slot="operation" slot-scope="text, record">
                    <a @click="handleViewDetail(record)">查看</a>
                  </template>
                </a-table>
              </div>

              <!-- 连接条数错误列表 -->
              <div v-show="currentPointTab === 1" class="error-section">
                <a-table :columns="pointColumns" :data-source="pointErrorLists.numberOfErrorsList"
                  :pagination="getPointPagination('numberOfErrorsList')"
                  @change="(pagination) => handlePointTableChange(pagination, 'numberOfErrorsList')" size="middle"
                  bordered :rowKey="(record, index) => record.id + index"
                  :row-class-name="(record) => record.id === currentViewDetailId ? 'highlight-row' : ''"
                  :scroll="{ y: 580 }">
                  <template slot="operation" slot-scope="text, record">
                    <a @click="handleViewDetail(record)">查看</a>
                  </template>
                </a-table>
              </div>

              <!-- 空值列表 -->
              <div v-show="currentPointTab === 2" class="error-section">
                <a-table :columns="pointColumns" :data-source="pointErrorLists.nullValueList"
                  :pagination="getPointPagination('nullValueList')"
                  @change="(pagination) => handlePointTableChange(pagination, 'nullValueList')" size="middle" bordered
                  :rowKey="(record, index) => record.id + index"
                  :row-class-name="(record) => record.id === currentViewDetailId ? 'highlight-row' : ''"
                  :scroll="{ y: 580 }">
                  <template slot="operation" slot-scope="text, record">
                    <a @click="handleViewDetail(record)">查看</a>
                  </template>
                </a-table>
              </div>

              <!-- 填写错误列表 -->
              <div v-show="currentPointTab === 3" class="error-section">
                <a-table :columns="pointColumns" :data-source="pointErrorLists.fillInTheErrorList"
                  :pagination="getPointPagination('fillInTheErrorList')"
                  @change="(pagination) => handlePointTableChange(pagination, 'fillInTheErrorList')" size="middle"
                  bordered :rowKey="(record, index) => record.id + index"
                  :row-class-name="(record) => record.id === currentViewDetailId ? 'highlight-row' : ''"
                  :scroll="{ y: 580 }">
                  <template slot="operation" slot-scope="text, record">
                    <a @click="handleViewDetail(record)">查看</a>
                  </template>
                </a-table>
              </div>
            </div>
          </div>
        </a-tab-pane>

        <!-- 管线表标签页 -->
        <a-tab-pane key="2" tab="管线表">
          <!-- 刷新按钮 -->
          <div class="refresh-button-container">
            <a-button type="primary" icon="sync" @click="refreshErrorDetailData">刷新</a-button>
          </div>
          <div class="custom-tabs">
            <div class="tab-header">
              <div v-for="(tab, index) in pipelineErrorTabs" :key="index"
                :class="['tab-item', currentPipelineTab === index ? 'active' : '']" @click="currentPipelineTab = index">
                <span class="tab-text">{{ tab.title }}</span>
                <span class="tab-badge">{{ pipelineErrorLists[tab.key].length }}</span>
              </div>
            </div>

            <div class="tab-content">
              <!-- 填写错误列表 -->
              <div v-show="currentPipelineTab === 0" class="error-section">
                <a-table :columns="pipelineColumns" :data-source="pipelineErrorLists.fillInTheErrorList"
                  :pagination="getPipelinePagination('fillInTheErrorList')"
                  @change="(pagination) => handlePipelineTableChange(pagination, 'fillInTheErrorList')" size="middle"
                  bordered :rowKey="(record, index) => index"
                  :row-class-name="(record) => record.id === currentViewDetailId ? 'highlight-row' : ''"
                  :scroll="{ y: 580 }">
                  <template slot="operation" slot-scope="text, record">
                    <a @click="handleViewDetail(record)">查看</a>
                  </template>
                </a-table>
              </div>

              <!-- 空值列表 -->
              <div v-show="currentPipelineTab === 1" class="error-section">
                <a-table :columns="pipelineColumns" :data-source="pipelineErrorLists.nullValueList"
                  :pagination="getPipelinePagination('nullValueList')"
                  @change="(pagination) => handlePipelineTableChange(pagination, 'nullValueList')" size="middle"
                  bordered :rowKey="(record, index) => index"
                  :row-class-name="(record) => record.id === currentViewDetailId ? 'highlight-row' : ''"
                  :scroll="{ y: 580 }">
                  <template slot="operation" slot-scope="text, record">
                    <a @click="handleViewDetail(record)">查看</a>
                  </template>
                </a-table>
              </div>

              <!-- 管线超长列表 -->
              <div v-show="currentPipelineTab === 2" class="error-section">
                <a-table :columns="pipelineColumns" :data-source="pipelineErrorLists.pipelineIsTooLongList"
                  :pagination="getPipelinePagination('pipelineIsTooLongList')"
                  @change="(pagination) => handlePipelineTableChange(pagination, 'pipelineIsTooLongList')" size="middle"
                  bordered :rowKey="(record, index) => index"
                  :row-class-name="(record) => record.id === currentViewDetailId ? 'highlight-row' : ''"
                  :scroll="{ y: 580 }">
                  <template slot="operation" slot-scope="text, record">
                    <a @click="handleViewDetail(record)">查看</a>
                  </template>
                </a-table>
              </div>
            </div>
          </div>
        </a-tab-pane>
      </a-tabs>
    </a-drawer>

    <!-- 插入项目弹窗 -->
    <a-modal title="插入项目" :visible="insertProjectVisible" :confirmLoading="insertProjectLoading"
      @ok="handleInsertProjectOk" @cancel="handleInsertProjectCancel" :getContainer="getContainer">
      <a-spin :spinning="insertProjectLoading">
        <a-form :form="insertProjectForm" layout="vertical">
          <a-form-item label="选择用户">
            <a-select showSearch placeholder="请选择用户" :filterOption="filterUserOption" @change="handleUserChange"
              v-decorator="[
                'userId',
                { rules: [{ required: true, message: '请选择用户!' }] }
              ]">
              <a-select-option v-for="user in userList" :key="user.id" :value="user.id">
                {{ user.userName }} ({{ user.phone }})
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="选择项目">
            <a-select showSearch placeholder="请选择项目" :filterOption="filterProjectOption" v-decorator="[
              'projectId',
              { rules: [{ required: true, message: '请选择项目!' }] }
            ]" :disabled="!selectedUserPhone">
              <a-select-option v-for="project in projectList" :key="project.id" :value="project.id">
                {{ project.projectName }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>

  </div>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import * as echarts from 'echarts'

export default {
  mixins: [mixinViewModule],
  name: 'ToolbarModule',
  components: {
  },
  props: {
    handleLayerRefresh: Number,
    handleLayerData: {
      type: Array,
      default: [],
    }, // 树状菜单
    currentBaseMap: {
      type: String,
      default: '天地影像',
    },
    markerPropList: {
      type: Array,
      default: [],
    },
    linePropList: {
      type: Array,
      default: [],
    },
    projectId: {
      type: String,
      default: null,
    }
  },
  data () {
    return {
      //查看图层 begin
      confirmLoading: false,
      collapsed: false,
      selectedKeys: [], // 当前选中的菜单项
      primitivehandleLayerData: [],
      handleLayerDataList: [],
      //end
      exportDialogVisible: false,
      exportLoading: false,
      templateList: [],
      selectedTemplateType: null,
      exportForm: null,

      currentProjectId: this.projectId, //当前项目id，优先使用传入的projectId
      exportDataUrl: '',
      query: {},
      needQuery: false,
      activeDropdown: null,
      selectionDialogVisible: false,
      selectionLoading: false,
      tubesOrLines: 1,
      connectivityNumber: undefined,
      fieldList: [],
      filterConditions: [
        {
          fieldName: undefined,
          condition: '',
        },
      ],
      selectionForm: null,
      rawFieldData: [],
      andWithOr: 1,
      /**物探点过滤 */
      filtrationList: [],
      filtrationConditions: [{}],
      batchEditVisible: false,
      batchEditLoading: false,
      showBatchEditFields: false,
      filterResultCount: 0,
      batchEditFields: [
        {
          fieldName: '',
          originalValue: '',
          newValue: '',
          type: 'input',
          options: []
        }
      ],
      filterConditionSummary: '',
      batchEditStep: 1, // 1: 过滤条件, 2: 修改字段
      filterResult: null, // 存储过滤结果数据
      statisticsVisible: false,
      statistics: {
        tubeTypes: [],
        lineTypes: []
      },
      dataCheckDialogVisible: false,
      dataCheckLoading: false,
      dataCheckForm: {
        errorCheckRange: 1,
        errorCheckConditions: [1, 2],
        pointList: [],
        projectManagementId: 0
      },
      allSelected: false,
      showErrorDetailDialog: false,
      errorCheckResults: null,
      pointColumns: [
        { title: '物探点号', dataIndex: 'intuitionPoint', width: '20%' },
        { title: '错误描述', dataIndex: 'errorDescription', width: '65%' },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      pipelineColumns: [
        {
          title: '序号',
          dataIndex: 'index',
          width: '10%',
          customRender: (text, record, index) => index + 1
        },
        { title: '连接点号', dataIndex: 'connectionPointNumber', width: '20%' },
        { title: '被连接点号', dataIndex: 'theDotNumberIsConnected', width: '20%' },
        { title: '错误描述', dataIndex: 'errorDescription', width: '35%' },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      pointPagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true
      },
      pipelinePagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true
      },
      pointErrorLists: {
        isolationPointList: [], // 孤立点列表
        numberOfErrorsList: [], // 连接条数错误列表
        nullValueList: [], // 空值列表
        fillInTheErrorList: [] // 填写错误列表
      },
      pointPaginations: {
        isolationPointList: {
          current: 1,
          pageSize: 10,
          total: 0
        },
        numberOfErrorsList: {
          current: 1,
          pageSize: 10,
          total: 0
        },
        nullValueList: {
          current: 1,
          pageSize: 10,
          total: 0
        },
        fillInTheErrorList: {
          current: 1,
          pageSize: 10,
          total: 0
        }
      },
      // 管点表错误类型标签
      currentPointTab: 0,
      pointErrorTabs: [
        { title: '孤立点', key: 'isolationPointList' },
        { title: '连接条数错误', key: 'numberOfErrorsList' },
        { title: '空值', key: 'nullValueList' },
        { title: '填写错误', key: 'fillInTheErrorList' }
      ],
      pipelineErrorTabs: [
        { title: '填写错误', key: 'fillInTheErrorList' },
        { title: '空值', key: 'nullValueList' },
        { title: '管线超长', key: 'pipelineIsTooLongList' }
      ],
      pipelineErrorLists: {
        fillInTheErrorList: [],
        nullValueList: [],
        pipelineIsTooLongList: []
      },
      currentPipelineTab: 0,

      // 添加管线表分页配置
      pipelinePaginations: {
        fillInTheErrorList: {
          current: 1,
          pageSize: 10,
          total: 0
        },
        nullValueList: {
          current: 1,
          pageSize: 10,
          total: 0
        },
        pipelineIsTooLongList: {
          current: 1,
          pageSize: 10,
          total: 0
        }
      },
      // 插入项目相关数据
      insertProjectVisible: false,
      insertProjectLoading: false,
      insertProjectForm: null,
      userList: [],
      projectList: [],
      selectedUserPhone: '',
      statisticsData: [], // 确保初始化为数组
      showEcharts: true, // 默认显示图表视图
      pointsChart: null, // 点统计图表实例
      linesChart: null, // 管线统计图表实例
      submitting: false, // 加载状态
      deriveType: 'excel',
      tabsType: '1',
      currentViewDetailId: null
    }
  },

  watch: {
    projectId: {
      immediate: true,
      handler (val) {
        if (val) {
          this.currentProjectId = val;
        }
      }
    },
    currentProjectId: {
      immediate: true,
      handler (val) {
        // 当 currentProjectId 变化时，通知父组件
        this.$emit('update:project-id', val)
      },
    },
    handleLayerData (newVal) {
      this.primitivehandleLayerData = JSON.parse(JSON.stringify(newVal))
    },
    // 监听 handleLayerReset 的变化，重置显示列表
    handleLayerRefresh (newVal, oldVal) {
      this.primitivehandleLayerData = JSON.parse(JSON.stringify(this.handleLayerData))
      this.handleLayerDataList = this.primitivehandleLayerData[0].children;
    },
    showEcharts (val) {
      if (val) {
        this.$nextTick(() => {
          this.initChart()
        })
      }
    },
    statisticsData: {
      handler (newVal) {
        if (this.showEcharts && Array.isArray(newVal)) {
          this.$nextTick(() => {
            this.updateChartData()
          })
        }
      },
      deep: true
    }
  },
  created () {
    this.exportForm = this.$form.createForm(this)
    this.selectionForm = this.$form.createForm(this)
    this.insertProjectForm = this.$form.createForm(this)

    // 配置message的挂载节点
    this.$message.config({
      top: `100px`,
      duration: 2,
      maxCount: 1,
      getContainer: () => document.getElementById('pipeline-mapping')
    })

    document.addEventListener('click', this.closeDropdowns)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.closeDropdowns)
    // 销毁图表实例
    if (this.pointsChart) {
      this.pointsChart.dispose()
      this.pointsChart = null
    }
    if (this.linesChart) {
      this.linesChart.dispose()
      this.linesChart = null
    }
  },
  methods: {
    getContainer () {
      return document.getElementById('pipeline-mapping')
    },
    toggleDropdown (dropdownName) {
      if (dropdownName == 'viewLayers') { //初始化查看图层

        this.selectedKeys = [this.primitivehandleLayerData[0].key];
        this.handleLayerDataList = this.primitivehandleLayerData[0].children;
      }
      if (this.activeDropdown === dropdownName) {
        this.activeDropdown = null
      } else {
        this.activeDropdown = dropdownName
      }
    },
    closeDropdowns (event) {
      // 如果点击的不是下拉框内部元素，则关闭所有下拉框
      if (!event.target.closest('.dropdown-container')) {

        this.activeDropdown = null
      }
    },
    handlePipelineTool (type) {
      this.activeDropdown = null
      if (type === 'batchEdit') {
        this.batchEditVisible = true
        this.handleFeatureChange()
      } else if (type === 'statistics') {
        this.showStatistics()
      } else if (type === 'insertProject') {
        this.showInsertProjectDialog()
      } else {
        this.$emit('pipeline-tool-click', type)
      }
    },
    handleAssistTool (type) {
      this.activeDropdown = null
      if (type === 'createSelection') {
        this.selectionDialogVisible = true
        this.handleFeatureChange()
        // this.getFieldList()
      } else {
        this.$emit('assist-tool-click', type)
      }
    },
    handleBaseMapChange (type) {
      this.activeDropdown = null
      this.$emit('basemap-change', type)
    },
    handleImportGIS () {
      this.$emit('import-gis')
    },
    showExportDialog () {
      this.selectedTemplateType = ''
      this.activeDropdown = null
      this.deriveType = 'excel'
      this.exportDialogVisible = true
      this.getTemplateList()
    },
    async getTemplateList () {
      try {
        const res = await this.$http.get('/gis-manager/foundation/template/all/list', {
          params: {
            templateType: this.selectedTemplateType
          }
        })
        if (res.code === 0) {
          this.templateList = res.data || []
        } else {
          this.$message.error(res.message || '获取模板列表失败')
        }
      } catch (error) {
        console.error('获取模板列表失败:', error)
        this.$message.error('获取模板列表失败')
      }
    },
    handleTemplateChange (value) {
      const template = this.templateList.find((item) => item.id === value)
      if (template) {
        this.selectedTemplateType = template.templateType
      }
    },
    async handleExport () {
      if (!this.currentProjectId) {
        this.$message.error('请先选择项目')
        return
      }
      if (this.deriveType == 'excel') {
        this.exportForm.validateFields(async (err, values) => {
          if (err) return

          this.exportLoading = true
          try {
            if (this.selectedTemplateType === 1) {
              this.exportDataUrl = 'gis-manager/diagramming/point/export/list'
            } else if (this.selectedTemplateType === 2) {
              this.exportDataUrl = 'gis-manager/diagramming/pipe/export/list'
            }

            this.query = {
              templateId: values.templateId,
              projectManagementId: this.currentProjectId,
            }

            await this.exportHandle()
            this.exportDialogVisible = false
          } catch (error) {
            console.error('导出失败:', error)
            this.$message.error('导出失败')
          } finally {
            this.exportLoading = false
          }
        })
      } else if (this.deriveType == 'cad') {
        // 1. 直接使用后端完整URL（跳过任何本地代理）
        try {
          // 使用封装好的下载方法
          await this.downloadBinaryFile(
            `/gis-manager/diagramming/project/generate/${this.currentProjectId}`,
            {},
            'cad.dxf'
          );
          this.$message.success('DXF文件下载成功');
          this.exportDialogVisible = false;
        } catch (error) {
          this.$message.error(error.response?.data?.message || 'DXF文件下载失败');
        } finally {
          this.exportLoading = false;
        }
      }
    },
    async getFieldList () {
      try {
        const res = await this.$http.post('/gis-manager/foundation/attribute/filter/conditions', {
          tenantId: '',
          tubeClassCode: 'JS',
          tubesOrLines: this.tubesOrLines,
        })
        if (res.code === 0) {
          this.rawFieldData = res.data || []
          this.fieldList = res.data.map((item) => ({
            label: item.attributeName,
            value: item.id,
            elementSettingList: item.elementSettingList || [],
          }))
        } else {
          this.$message.error(res.message || '获取字段列表失败')
        }
      } catch (error) {
        console.error('获取字段列表失败:', error)
        this.$message.error('获取字段列表失败')
      }
    },
    addFilterCondition () {
      // 获取当前可用字段数量
      const availableFieldsCount = this.availableFields(this.filterConditions.length).length

      // 检查是否还有可用字段
      if (availableFieldsCount === 0) {
        this.$message.warning('已达到最大过滤条件数量')
        return
      }

      this.filterConditions.push({
        fieldName: undefined,
        condition: '',
      })
    },
    removeFilterCondition (index) {
      this.filterConditions.splice(index, 1)
    },
    /**
     * 处理字段变化事件
     * @param {string|number} value - 选择的字段值
     * @param {number} index - 当前字段在filterConditions中的索引
     * @description 当字段发生变化时，重置对应的condition值
     */
    handleFieldChange (value, index) {
      if (typeof index !== 'number' || index < 0 || index >= this.filterConditions.length) {
        console.warn('Invalid index in handleFieldChange')
        return
      }
      this.filterConditions[index].condition = ''
    },
    availableFields (currentIndex) {
      const selectedFields = this.filterConditions
        .map((item) => item.fieldName)
        .filter((value, index) => index !== currentIndex)

      return this.fieldList.filter((field) => !selectedFields.includes(field.value))
    },
    getFieldElements (fieldId) {
      const field = this.rawFieldData.find((f) => f.id === fieldId)
      return field?.elementSettingList?.length ? field.elementSettingList : null
    },
    // 重置弹窗内容
    resetSelectionForm () {
      this.tubesOrLines = 1
      this.connectivityNumber = undefined
      this.filterConditions = [
        {
          fieldName: undefined,
          condition: '',
        },
      ]
      this.andWithOr = 1
      this.fieldList = []
      this.rawFieldData = []
    },
    // 取消按钮处理
    handleSelectionCancel () {
      this.selectionDialogVisible = false
      this.resetSelectionForm()
    },
    async handleSelectionSubmit () {
      // 关闭错误详情弹窗
      this.showErrorDetailDialog = false
      try {
        // 验证过滤条件
        if (!this.validateFilterConditions()) {
          return;
        }
        this.selectionLoading = true
        const submitData = {
          andWithOr: this.andWithOr, //过滤条件'和'OR'或'
          filterConditionsList: this.filtrationConditions.map((item) => ({
            attributeName: item.label,
            attributeValue:
              Array.isArray(item.condition) && item.condition.length > 1
                ? item.condition[item.condition.length - 1]
                : item.condition,
          })),
          ifPipeline: this.tubesOrLines,
          projectManagementId: this.currentProjectId,
        }
        if (this.tubesOrLines == 1) {
          submitData.connectedNumbers = this.connectivityNumber //连通数
        }
        const res = await this.$http.post('/gis-manager/diagramming/project/pipeline/filtration', submitData)
        if (res.code === 0) {
          this.$message.success('过滤成功')
          this.selectionDialogVisible = false
          //     // 构造过滤结果数据
          const filterResult = {
            type: this.tubesOrLines === 1 ? '管点' : '管线',
            data: this.tubesOrLines === 1 ? res.data?.pipePointInfoPcList || [] : res.data?.pipelineInfoPcList || [],
            columns:
              this.tubesOrLines === 1
                ? [
                  {
                    title: '序号',
                    dataIndex: 'index',
                    width: 80,
                    customRender: (text, record, index) => index + 1,
                  },
                  { title: '物探点号', dataIndex: 'intuitionPoint', width: 120 },
                  { title: '管点类型', dataIndex: 'tubeClassCode', width: 120 },
                ]
                : [
                  {
                    title: '序号',
                    dataIndex: 'index',
                    width: 80,
                    customRender: (text, record, index) => index + 1,
                  },
                  { title: '连接点号', dataIndex: 'connectionPointNumber', width: 120 },
                  { title: '被连接点号', dataIndex: 'theDotNumberIsConnected', width: 120 },
                  // { title: '管线长度', dataIndex: 'pipelineLength', width: 120 }
                ],
          }

          // 触发过滤成功事件
          this.$emit('filter-success', filterResult)
          // 重置表单
          this.resetSelectionForm()
        } else {
          this.$message.error(res.message || '过滤失败')
        }
      } catch (error) {
      } finally {
        this.selectionLoading = false
      }
    },
    isDateField (fieldId) {
      const field = this.rawFieldData.find((f) => f.id === fieldId)
      // 根据字段名判断是否为时间类型，可以根据实际需求调整判断条件
      return field?.attributeName?.includes('时间') || field?.attributeName?.includes('日期')
    },

    handleDateChange (dateString, index) {
      this.filterConditions[index].condition = dateString
    },

    /**物探点过滤方法 */
    /**
     * 特征类型改变
     */
    handleFeatureChange () {
      let propList = []
      this.filtrationConditions = [{}]
      switch (this.tubesOrLines) {
        case 1:
          propList = this.markerPropList
          break
        case 2:
          propList = this.linePropList
          break
        default:
          break
      }
      // 重置过滤条件为初始状态
      this.getFiltrationList(propList)
    },
    /**
     * 获取过滤列表
     * @param list 原型集合
     */
    getFiltrationList (list) {
      this.filtrationList = list.map((item) => ({
        label: item.label, //字段说明
        type: item.type, //字段类型
        list: item.list != undefined ? item.list : null, //下拉框选择集合
        options: item.options != undefined ? item.options : null, //复合框选择集合
        editor:
          item.inputData?.data == undefined
            ? false //是否编辑 如果不能编辑就是 false
            : {
              flag: false, //默认不可编辑状态
              defaultValue: item.inputData.data.defaultValue, //默认值
            },
      }))
    },
    /**
     * 选择后修改其中的值
     * @param item 选中值
     */
    updatefiltrationList (item, index) {
      // 查找匹配的 filt
      const matchedFilt = this.filtrationList.find((filt) => filt.label === item.label)
      // 如果找到匹配的 filt，则深拷贝并更新 filtrationConditions
      if (matchedFilt) {
        // 深拷贝 matchedFilt
        const copiedFilt = JSON.parse(JSON.stringify(matchedFilt))
        // 使用 Vue 的 $set 方法确保响应式更新
        this.$set(this.filtrationConditions, index, copiedFilt)
      } else {
        console.warn(`未找到 label 为 ${item.label} 的 filt`)
      }
    },
    /**
     * 筛选列表
     */
    fFiltrationList () {
      // 获取 filtrationConditions 中所有 label 的值
      const conditionLabels = this.filtrationConditions.map((item) => item?.label)
      // 深拷贝 filtrationList
      const filtrationListCopy = JSON.parse(JSON.stringify(this.filtrationList))
      // 过滤 list，保留 label 不在 conditionLabels 中的项
      let filteredList = filtrationListCopy.filter((item) => !conditionLabels.includes(item.label))
      // 返回过滤后的结果，但不修改原始数据
      return filteredList
    },
    /**
     * 添加过滤列
     */

    addFilterConditions () {
      // 限制最多三条过滤条件
      if (this.filtrationConditions.length >= 3) {
        this.$message.warning('最多只能添加三条过滤条件')
        return
      }
      this.filtrationConditions.push({})
    },
    //删除过滤列
    removeFilterConditions (index) {
      this.filtrationConditions.splice(index, 1)
    },
    //切换框
    toggleModule (item) {
      console.log(item)
      item.editor.flag = !item.editor.flag
      //如果是树型菜单
      if (item.editor.flag && item.type == 'options') {
        let value = item.condition
        //获取树型菜单中最后的元素
        item.condition = value[value.length - 1]
      } else if (item.type == 'options') {
        //避免冲突切换树形菜单
        item.condition = this.optionsResolver(item)
      } else {
      }
    },
    /**
     * 树状选择框解析器
     * 因为树状选择框中绑定的值不同所以需要解析
     * @param item 树型菜单对象
     *
     */
    optionsResolver (item) {
      //返回值
      let value = undefined
      //循环树型菜单属性
      item.options.forEach((array) => {
        //循环子属性
        array.children.forEach((element) => {
          //如果当前输入值与子属性列表中向匹配则添加为 [key,value] 数组
          if (element.value == item.condition) {
            value = [array.value, element.value]
          }
        })
      })

      return value
    },
    /**
     * 只展示最后一个值
     * @param param0 树型下拉框值
     */
    displayRender ({ labels }) {
      return labels[labels.length - 1]
    },
    // 批量修改相关方法
    async handleBatchEditSubmit () {
      if (this.batchEditStep === 1) {
        try {
          // 验证过滤条件
          if (!this.validateFilterConditions()) {
            return;
          }

          this.batchEditLoading = true;
          const submitData = {
            andWithOr: this.andWithOr,
            filterConditionsList: this.filtrationConditions
              .filter((item) => item.label && item.condition)
              .map((item) => ({
                attributeName: item.label,
                attributeValue:
                  Array.isArray(item.condition) && item.condition.length > 1
                    ? item.condition[item.condition.length - 1]
                    : item.condition,
              })),
            ifPipeline: this.tubesOrLines,
            projectManagementId: this.currentProjectId,
          };

          if (this.tubesOrLines === 1 && this.connectivityNumber !== undefined) {
            submitData.connectedNumbers = this.connectivityNumber;
          }

          const res = await this.$http.post('/gis-manager/diagramming/project/pipeline/filtration', submitData);

          if (res.code === 0) {
            const count =
              this.tubesOrLines === 1
                ? (res.data?.pipePointInfoPcList || []).length
                : (res.data?.pipelineInfoPcList || []).length;

            if (count === 0) {
              this.$message.warning('未找到符合条件的数据，请调整过滤条件后重试');
              return;
            }

            // 保存过滤结果
            this.filterResult = res.data;
            this.filterResultCount = count;

            // 生成过滤条件摘要
            this.filterConditionSummary = this.filtrationConditions
              .filter((item) => item.label && item.condition)
              .map(
                (item) =>
                  `${item.label}: ${Array.isArray(item.condition) ? item.condition[item.condition.length - 1] : item.condition}`
              )
              .join('; 且 ');

            // 显示第二步
            this.showBatchEditFields = true;
            this.batchEditStep = 2;

            // 显示成功消息
            this.$message.success(`找到 ${count} 条符合条件的数据`);
          } else {
            this.$message.error(res.message || '过滤失败');
          }
        } catch (error) {
          console.error('过滤失败:', error);
          this.$message.error('过滤失败，请重试');
        } finally {
          this.batchEditLoading = false;
        }
      } else {
        // 第二步：验证并提交修改
        if (!this.validateBatchEditFields()) {
          return;
        }
        await this.submitBatchEdit();
      }
    },

    // 更新过滤结果数量
    updateFilterResultCount (count) {
      this.filterResultCount = count;
      // 如果结果为0，显示提示信息
      if (count === 0) {
        this.$message.info('当前条件下没有匹配的数据');
      }
    },

    // 应用过滤条件
    applyFilterConditions () {
      if (!this.validateFilterConditions()) {
        return;
      }

      // 构建过滤参数
      const params = {
        conditions: this.filtrationConditions.filter(item => item.label && item.condition),
        andWithOr: this.andWithOr
      };

      // 调用接口获取过滤结果数量
      this.$http.post('/your-filter-api-endpoint', params)
        .then(res => {
          if (res.code === 0) {
            this.updateFilterResultCount(res.data.count || 0);
            this.filterConditionSummary = `符合条件的数据共 ${this.filterResultCount} 条`;
          } else {
            this.$message.error(res.message || '获取过滤结果失败');
          }
        })
        .catch(error => {
          console.error('获取过滤结果失败:', error);
          this.$message.error('获取过滤结果失败');
        });
    },

    // 重置过滤条件
    resetFilterConditions () {
      this.filtrationConditions = [{
        label: '',
        condition: '',
        type: '',
        options: []
      }];
      this.filterResultCount = 0;
      this.filterConditionSummary = '';
      this.andWithOr = 1;
    },

    handleBatchEditCancel () {
      this.batchEditVisible = false
      this.showBatchEditFields = false
      this.filterResultCount = 0
      this.filterConditionSummary = ''
      this.batchEditStep = 1
      this.filterResult = null
      this.batchEditFields = [
        {
          fieldName: '',
          originalValue: '',
          newValue: '',
          type: 'input',
          options: []
        }
      ]
      this.resetSelectionForm()
    },

    handlePrevStep () {
      this.batchEditStep = 1
      this.showBatchEditFields = false
      this.batchEditFields = [
        {
          fieldName: '',
          originalValue: '',
          newValue: '',
          type: 'input',
          options: []
        }
      ]
      this.filterResultCount = 0
      this.filterConditionSummary = ''
    },

    // 获取字段类型
    getFieldType (fieldName) {
      // 首先从已选的过滤条件中查找
      let field = this.filtrationConditions.find((item) => item.label === fieldName)
      if (field) {
        return field.type
      }

      // 如果在已选条件中找不到，则从完整的字段列表中查找
      field = this.filtrationList.find((item) => item.label === fieldName)
      return field ? field.type : 'input'
    },

    // 获取字段可选值（针对select类型）
    getFieldValues (fieldName) {
      // 首先从已选的过滤条件中查找
      let field = this.filtrationConditions.find((item) => item.label === fieldName)
      if (field && field.list) {
        return field.list
      }

      // 如果在已选条件中找不到，则从完整的字段列表中查找
      field = this.filtrationList.find((item) => item.label === fieldName)
      return field && field.list ? field.list : []
    },

    // 获取字段选项（针对options类型）
    getFieldOptions (fieldName) {
      // 首先从已选的过滤条件中查找
      let field = this.filtrationConditions.find((item) => item.label === fieldName)
      if (field && field.options) {
        return field.options
      }

      // 如果在已选条件中找不到，则从完整的字段列表中查找
      field = this.filtrationList.find((item) => item.label === fieldName)
      return field && field.options ? field.options : []
    },

    // 获取字段的编辑器配置
    getFieldEditor (fieldName) {
      // 首先从已选的过滤条件中查找
      let field = this.filtrationConditions.find((item) => item.label === fieldName)
      if (field) {
        return field.editor !== false
      }

      // 如果在已选条件中找不到，则从完整的字段列表中查找
      field = this.filtrationList.find((item) => item.label === fieldName)
      return field && field.editor !== false
    },

    // 切换编辑模式
    toggleEditMode (index) {
      console.log('toggleEditMode调用，索引:', index);

      // 确保索引有效且字段存在
      if (index === undefined || index < 0 || index >= this.batchEditFields.length) {
        console.error('无效的字段索引:', index);
        return;
      }

      const field = this.batchEditFields[index];

      // 检查字段是否存在
      if (!field) {
        console.error('字段不存在:', index);
        return;
      }

      // 检查editMode是否存在，不存在则初始化
      if (!field.editMode || typeof field.editMode !== 'object') {
        this.$set(field, 'editMode', { flag: false });
      }

      // 切换标志前记录当前状态
      const oldFlag = field.editMode.flag;
      // 使用Vue的响应式方法设置新值
      this.$set(field.editMode, 'flag', !oldFlag);

      console.log('字段编辑模式从', oldFlag, '变为', field.editMode.flag);

      // 根据字段类型处理值的转换
      const fieldType = this.getFieldType(field.fieldName);

      try {
        // 当切换到输入模式时（editMode.flag为true）
        if (field.editMode.flag && fieldType === 'options') {
          // 如果当前值是数组，取最后一个元素
          if (Array.isArray(field.newValue) && field.newValue.length > 0) {
            // 使用Vue的响应式方法设置新值
            this.$set(field, 'newValue', field.newValue[field.newValue.length - 1]);
          } else if (field.newValue && typeof field.newValue === 'object') {
            // 如果是复杂对象，尝试获取可能的值属性
            this.$set(field, 'newValue', field.newValue.value || field.newValue.label || '');
          }
        }
        // 当切换到选择模式时（editMode.flag为false）
        else if (!field.editMode.flag && fieldType === 'options') {
          // 获取选项列表
          const options = this.getFieldOptions(field.fieldName);
          // 确保optionsResolver存在且是函数
          if (typeof this.optionsResolver === 'function' && options && options.length > 0) {
            const resolvedValue = this.optionsResolver({
              options: options,
              condition: field.newValue,
            });
            // 使用Vue的响应式方法设置新值
            this.$set(field, 'newValue', resolvedValue);
          } else {
            console.warn('无法解析选项值，可能是options为空或resolver未定义');
          }
        }
      } catch (error) {
        console.error('处理字段值转换时出错:', error);
        // 发生错误时，至少保留编辑模式的切换
      }
      console.log('aaa', field);

    },

    // 添加批量修改字段

    addBatchEditField () {
      this.batchEditFields.push({
        fieldName: '',
        originalValue: '',
        newValue: '',
        type: 'input',
        options: []
      });
    },

    // 删除批量修改字段
    removeBatchEditField (index) {
      this.batchEditFields.splice(index, 1)
    },

    // 获取可用的字段列表（排除已选择的字段）
    getAvailableFields (currentIndex) {
      const selectedFields = this.batchEditFields
        .map((field) => field.fieldName)
        .filter((_, index) => index !== currentIndex)


      // 使用与第一步相同的数据源 - filtrationList
      // 而不是直接从filtrationConditions中筛选字段
      const filtrationListCopy = JSON.parse(JSON.stringify(this.filtrationList))

      // 过滤掉已经在修改字段中选择的字段
      return filtrationListCopy.filter((item) => !selectedFields.includes(item.label))
    },

    // 处理字段变更
    handleField2Change (value, index) {
      console.log('字段变更:', value, index);

      if (typeof index !== 'number' || index < 0 || index >= this.batchEditFields.length) {
        console.warn('无效的索引值在handleField2Change中')
        return
      }

      const field = this.batchEditFields[index]
      field.originalValue = this.getFieldOriginalValue(value)

      // 根据字段类型设置合适的初始值
      const fieldType = this.getFieldType(value)
      if (fieldType === 'options' || fieldType === 'select') {
        // 对于级联选择器、多选选择器等，使用空数组而不是空字符串
        field.newValue = []
      } else {
        // 对于文本输入等，使用空字符串
        field.newValue = ''
      }

      // 确保编辑模式正确设置
      if (!field.editMode) {
        this.$set(field, 'editMode', { flag: false })
      } else {
        this.$set(field.editMode, 'flag', false)
      }
    },

    // 获取字段原始值
    getFieldOriginalValue (fieldName) {
      if (!this.filterResult) return ''

      // 获取过滤条件中对应字段的值
      const filterCondition = this.filtrationConditions.find((item) => item.label === fieldName)
      if (filterCondition && filterCondition.condition) {
        return Array.isArray(filterCondition.condition)
          ? filterCondition.condition[filterCondition.condition.length - 1]
          : filterCondition.condition
      }

      return ''
    },

    async showStatistics () {
      this.statisticsVisible = true
      this.submitting = true
      await this.fetchStatisticsData()
      this.submitting = false

      this.$nextTick(() => {
        if (this.showEcharts) {
          this.initChart()
        }
      })
    },

    // 关闭统计弹窗
    handleCloseStatistics () {
      this.statisticsVisible = false
      // 清理图表实例
      if (this.pointsChart) {
        this.pointsChart.dispose()
        this.pointsChart = null
      }
      if (this.linesChart) {
        this.linesChart.dispose()
        this.linesChart = null
      }
    },

    // 获取统计数据
    async fetchStatisticsData () {
      try {
        // 确保 projectId 存在且正确
        if (!this.projectId) {
          console.error('项目ID不存在')
          this.$message.error('获取统计数据失败：项目ID不存在')
          return
        }

        console.log('正在获取统计数据，项目ID:', this.projectId)
        const res = await this.$http.get(`/gis-manager/diagramming/project/info/statistics/${this.projectId}`)

        if (res.code === 0) {
          console.log('获取到统计数据:', res.data)
          // 确保返回的数据是数组
          this.statisticsData = Array.isArray(res.data) ? res.data : []
        } else {
          console.error('获取统计数据接口错误:', res.message)
          this.$message.error(res.message || '获取统计数据失败')
        }
      } catch (error) {
        console.error('获取统计数据异常:', error)
        this.$message.error('获取统计数据失败')
      }
    },

    // 初始化图表
    initChart () {
      // 如果图表已存在先销毁
      if (this.pointsChart) {
        this.pointsChart.dispose()
      }
      if (this.linesChart) {
        this.linesChart.dispose()
      }

      if (this.$refs.pointsChart && this.$refs.linesChart) {
        console.log('初始化图表')
        this.pointsChart = echarts.init(this.$refs.pointsChart)
        this.linesChart = echarts.init(this.$refs.linesChart)
        this.updateChartData()
      } else {
        console.error('图表DOM元素不存在')
      }
    },

    // 更新图表数据
    updateChartData () {
      if (!this.pointsChart || !this.linesChart) {
        console.error('图表实例不存在')
        return
      }

      // 确保 statisticsData 是数组
      const data = Array.isArray(this.statisticsData) ? this.statisticsData : []
      console.log('更新图表数据:', data)

      if (data.length === 0) {
        const emptyOption = {
          title: {
            text: '暂无统计数据',
            left: 'center',
            top: 'center'
          }
        }
        this.pointsChart.setOption(emptyOption)
        this.linesChart.setOption(emptyOption)
        return
      }

      // 准备图表数据
      const categories = []
      const salientPoints = []
      const hiddenPoints = []
      const totalPoints = []
      const totalLines = []

      data.forEach(item => {
        categories.push(item.tubeClassName || '--')
        salientPoints.push(item.informationStatisticsResult.salientPoints || 0)
        hiddenPoints.push(item.informationStatisticsResult.hiddenPoint || 0)
        totalPoints.push(item.informationStatisticsResult.totalNumberOfPoints || 0)
        totalLines.push(item.informationStatisticsResult.totalNumberOfLines || 0)
      })

      // 点统计图表配置
      const pointsOption = {
        title: {
          text: '管点统计',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['明显点', '隐藏点', '点总数'],
          bottom: '5%'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: categories,
          axisLabel: {
            interval: 0,
            rotate: 30 // 如果类别名称较长，可以适当旋转标签
          }
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '明显点',
            type: 'bar',
            // 移除 stack 属性，使用 barGap 控制柱间距
            barGap: '30%',
            data: salientPoints,
            itemStyle: {
              color: '#FDC147'
            }
          },
          {
            name: '隐藏点',
            type: 'bar',
            data: hiddenPoints,
            itemStyle: {
              color: '#7C8AA7'
            }
          },
          {
            name: '点总数',
            type: 'line',
            data: totalPoints,
            symbolSize: 8,
            itemStyle: {
              color: '#52B2D8'
            },
            lineStyle: {
              width: 2,
              color: '#52B2D8'
            }
          }
        ]
      }

      // 管线统计图表配置
      const linesOption = {
        title: {
          text: '管线统计',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['管线总数', '管网长度'],
          bottom: '5%'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: categories
        },
        yAxis: [
          {
            type: 'value',
            name: '管线数量',
            position: 'left'
          },
          {
            type: 'value',
            name: '管网长度(m)',
            position: 'right'
          }
        ],
        series: [
          {
            name: '管线总数',
            type: 'bar',
            data: totalLines,
            yAxisIndex: 0,
            itemStyle: {
              color: '#0F6CD6'
            }
          },
          {
            name: '管网长度',
            type: 'line',
            yAxisIndex: 1,
            data: data.map(item => item.informationStatisticsResult.pipelineLength || 0),
            symbolSize: 8,
            itemStyle: {
              color: '#52B2D8'
            },
            lineStyle: {
              width: 2,
              color: '#52B2D8'
            }
          }
        ]
      }

      this.pointsChart.setOption(pointsOption)
      this.linesChart.setOption(linesOption)
    },

    // 格式化数字为千分位
    formatNumber (num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },


    //项目选择
    itemSelection () {
      this.showErrorDetailDialog = false
      this.$emit('item-selection', '');
    },
    // 处理菜单项选中事件
    handleLayerSelect ({ key }) {
      this.selectedKeys = [key];

      this.primitivehandleLayerData.forEach(item => {
        if (item.key == key) {
          this.handleLayerDataList = item.children;
          return;
        }
      })
    },
    showLayerType (item) {
      item.show = !item.show
      this.$emit('show-layer-type', item);
    },
    // 添加处理字段值变更的方法
    handleConditionChange (item, index) {
      // 检查是否是特殊字段（特征点、附属物、构筑物）且有值
      const specialFields = ['特征点', '附属物', '构筑物']
      if (specialFields.includes(item.label) && item.condition) {
        // 找出其他已选择的特殊字段
        this.filtrationConditions.forEach((condition, i) => {
          if (i !== index && specialFields.includes(condition.label)) {
            // 重置其他特殊字段的值
            this.$set(condition, 'condition', '')
          }
        })
      }
    },
    showDataCheckDialog () {
      this.dataCheckDialogVisible = true
      this.activeDropdown = null
    },

    async handleDataCheck () {
      if (this.dataCheckForm.errorCheckConditions.length === 0) {
        this.$message.error('请选择查错条件')
        return
      }

      this.dataCheckLoading = true
      try {
        // 计算错误检查条件
        const errorCheckConditions = this.dataCheckForm.errorCheckConditions.reduce((sum, current) => sum + current, 0)

        const params = {
          errorCheckRange: this.dataCheckForm.errorCheckRange,
          errorCheckConditions: errorCheckConditions,
          pointList: this.dataCheckForm.pointList,
          projectManagementId: this.currentProjectId
        }

        const res = await this.$http.post('/gis-manager/diagramming/project/data/checking', params)

        if (res.code === 0) {
          this.dataCheckDialogVisible = false
          setTimeout(() => {
            this.dataCheckLoading = false
            this.$message.success('数据查错成功')
          }, 1000)

          // 处理管点表错误数据
          const pointErrorTypeResult = res.data?.pointErrorTypeResult || {}
          this.$set(this, 'pointErrorLists', {
            isolationPointList: pointErrorTypeResult.isolationPointList || [],
            numberOfErrorsList: pointErrorTypeResult.numberOfErrorsList || [],
            nullValueList: pointErrorTypeResult.nullValueList || [],
            fillInTheErrorList: pointErrorTypeResult.fillInTheErrorList || []
          })

          // 处理管线表错误数据
          const pipelineErrorTypeResult = res.data?.pipelineErrorTypeResult || {}
          this.$set(this, 'pipelineErrorLists', {
            fillInTheErrorList: pipelineErrorTypeResult.fillInTheErrorList || [],
            nullValueList: pipelineErrorTypeResult.nullValueList || [],
            pipelineIsTooLongList: pipelineErrorTypeResult.pipelineIsTooLongList || []
          })

          // 更新各列表的分页数据
          this.$set(this, 'pointPaginations', {
            isolationPointList: {
              current: 1,
              pageSize: 10,
              total: this.pointErrorLists.isolationPointList.length
            },
            numberOfErrorsList: {
              current: 1,
              pageSize: 10,
              total: this.pointErrorLists.numberOfErrorsList.length
            },
            nullValueList: {
              current: 1,
              pageSize: 10,
              total: this.pointErrorLists.nullValueList.length
            },
            fillInTheErrorList: {
              current: 1,
              pageSize: 10,
              total: this.pointErrorLists.fillInTheErrorList.length
            }
          })

          // 更新管线表分页
          this.$set(this, 'pipelinePagination', {
            current: 1,
            pageSize: 10,
            total: this.getPipelineTotalErrors()
          })

          // 自动选择有数据的标签页
          this.selectFirstNonEmptyTab()

          // 显示错误详情对话框
          this.showErrorDetailDialog = true
          // 通知父组件关闭过滤详情弹窗
          this.$emit('close-filter-detail')

          // 初始化管线表分页
          Object.keys(this.pipelineErrorLists).forEach(key => {
            this.pipelinePaginations[key] = {
              ...this.pipelinePaginations[key],
              current: 1,
              total: this.pipelineErrorLists[key]?.length || 0
            }
          })
        } else {
          this.$message.error(res.message || '数据查错失败')
        }
      } catch (error) {
        console.error('数据查错失败:', error)
        this.$message.error('数据查错失败，请重试')
      } finally {

      }
    },

    // 计算管线表总错误数
    getPipelineTotalErrors () {
      return this.pipelineErrorLists.fillInTheErrorList.length +
        this.pipelineErrorLists.nullValueList.length +
        this.pipelineErrorLists.pipelineIsTooLongList.length
    },

    // 自动选择第一个有数据的标签页
    selectFirstNonEmptyTab () {
      const tabKeys = ['isolationPointList', 'numberOfErrorsList', 'nullValueList', 'fillInTheErrorList']
      for (let i = 0; i < tabKeys.length; i++) {
        if (this.pointErrorLists[tabKeys[i]]?.length > 0) {
          this.currentPointTab = i
          return
        }
      }
      // 如果所有标签页都没有数据，默认选择第一个
      this.currentPointTab = 0

      // 检查管线表是否有数据，如果有，则自动切换到管线表标签
      if (this.getPipelineTotalErrors() > 0) {
        this.$nextTick(() => {
          const tabsElement = document.querySelector('.ant-tabs-nav .ant-tabs-tab:nth-child(2)');
          if (tabsElement) {
            tabsElement.click();
            this.selectFirstNonEmptyPipelineTab();
          }
        });
      }
    },

    // 自动选择第一个有数据的管线标签页
    selectFirstNonEmptyPipelineTab () {
      const tabKeys = ['fillInTheErrorList', 'nullValueList', 'pipelineIsTooLongList']
      for (let i = 0; i < tabKeys.length; i++) {
        if (this.pipelineErrorLists[tabKeys[i]]?.length > 0) {
          this.currentPipelineTab = i
          return
        }
      }
      // 如果所有标签页都没有数据，默认选择第一个
      this.currentPipelineTab = 0
    },

    handleErrorDetailClose () {
      this.showErrorDetailDialog = false;
      this.errorCheckResults = null;
      this.currentViewDetailId = null; // 重置当前查看的记录ID
    },

    // 处理管线表分页变化
    handlePipelineTableChange (pagination, type) {
      this.pipelinePaginations[type] = {
        ...this.pipelinePaginations[type],
        current: pagination.current,
        pageSize: pagination.pageSize
      }
    },

    // 获取管线表分页配置
    getPipelinePagination (type) {
      return {
        ...this.pipelinePaginations[type],
        total: this.pipelineErrorLists[type]?.length || 0,
        showTotal: total => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        showLessItems: true, // 减少页码显示数量
        size: 'small' // 使用小型分页组件
      }
    },

    getPointErrorTypeTitle (type) {
      const titles = {
        fillInTheError: '填写错误',
        isolationPoint: '孤立点',
        nullValue: '空值',
        numberOfErrors: '连接条数错误'
      }
      return titles[type] || type
    },

    getPipelineErrorTypeTitle (type) {
      const titles = {
        fillInTheError: '填写错误',
        nullValue: '空值',
        pipelineIsTooLong: '管线超长'
      }
      return titles[type] || type
    },

    handlePointTableChange (pagination, type) {
      this.pointPaginations[type] = { ...this.pointPaginations[type], ...pagination }
    },

    handleViewDetail (record) {
      // 设置当前查看的记录ID
      this.currentViewDetailId = record.id;

      // 触发事件，向父组件发送查询信息
      this.$emit('query-map-message', {
        type: this.tabsType,
        data: record
      });
    },
    getPointPagination (type) {
      return {
        ...this.pointPaginations[type],
        showTotal: total => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        showLessItems: true, // 减少页码显示数量
        size: 'small' // 使用小型分页组件
      }
    },
    // 插入项目相关方法
    showInsertProjectDialog () {
      this.insertProjectVisible = true;
      this.loadUserList();
    },

    // 加载用户列表
    loadUserList () {
      this.insertProjectLoading = true;
      this.$http.get('/gis-manager/user/deploy/user/list/1').then(res => {
        if (res.code === 0 && res.data) {
          this.userList = res.data;
        } else {
          this.$message.error(res.message || '获取用户列表失败');
        }
      }).catch(err => {
        console.error('获取用户列表出错:', err);
        this.$message.error('获取用户列表失败');
      }).finally(() => {
        this.insertProjectLoading = false;
      });
    },

    // 用户选择改变事件
    handleUserChange (value) {
      const selectedUser = this.userList.find(user => user.id === value);
      if (selectedUser && selectedUser.phone) {
        this.selectedUserPhone = selectedUser.phone;
        this.loadProjectList(selectedUser.phone);
      } else {
        this.selectedUserPhone = '';
        this.projectList = [];
      }
    },

    // 加载项目列表
    loadProjectList (phone) {
      this.insertProjectLoading = true;
      this.projectList = [];
      this.$http.get(`/gis-manager/diagramming/project/list/items/${phone}/2`).then(res => {
        if (res.code === 0 && res.data) {
          this.projectList = res.data;
        } else {
          this.$message.error(res.message || '获取项目列表失败');
        }
      }).catch(err => {
        console.error('获取项目列表出错:', err);
        this.$message.error('获取项目列表失败');
      }).finally(() => {
        this.insertProjectLoading = false;
      });
    },

    // 用户过滤选项
    filterUserOption (input, option) {
      const userText = option.componentOptions.children[0].text.toLowerCase();
      return userText.indexOf(input.toLowerCase()) >= 0;
    },

    // 项目过滤选项
    filterProjectOption (input, option) {
      const projectText = option.componentOptions.children[0].text.toLowerCase();
      return projectText.indexOf(input.toLowerCase()) >= 0;
    },

    // 插入项目确认
    handleInsertProjectOk () {
      this.insertProjectForm.validateFields((err, values) => {
        if (err) return;

        this.insertProjectLoading = true;

        // 构建请求参数
        const params = {
          masterProjectManagementId: this.currentProjectId,
          slaveProjectManagementId: values.projectId
        };

        // 发送保存请求
        this.$http.post('/gis-manager/diagramming/project/insert/project', params).then(res => {
          if (res.code === 0) {
            this.$message.success('项目插入成功');
            this.insertProjectVisible = false;
            this.insertProjectForm.resetFields();
            this.selectedUserPhone = '';
            this.projectList = [];

            // 通知父组件刷新地图
            this.$emit('refresh-map');
          } else {
            this.$message.error(res.message || '项目插入失败');
          }
        }).catch(err => {
          console.error('项目插入出错:', err);
          this.$message.error('项目插入失败');
        }).finally(() => {
          this.insertProjectLoading = false;
        });
      });
    },

    // 插入项目取消
    handleInsertProjectCancel () {
      this.insertProjectVisible = false;
      this.insertProjectForm.resetFields();
      this.selectedUserPhone = '';
      this.projectList = [];
    },

    // 获取管点总数
    getTotalTubeCount () {
      if (!this.statistics.tubeTypes || this.statistics.tubeTypes.length === 0) {
        return 0;
      }
      return this.statistics.tubeTypes.reduce((total, item) => total + item.count, 0);
    },

    // 获取管线总数
    getTotalLinesCount () {
      if (!this.statistics.lineTypes || this.statistics.lineTypes.length === 0) {
        return 0;
      }
      return this.statistics.lineTypes.reduce((total, item) => total + item.count, 0);
    },

    // 获取管线总长度
    getTotalLength () {
      if (!this.statistics.lineTypes || this.statistics.lineTypes.length === 0) {
        return 0;
      }
      return this.statistics.lineTypes.reduce((total, item) => total + item.length, 0);
    },

    // 验证过滤条件是否填写完整
    validateFilterConditions () {
      const hasEmptyFields = this.filtrationConditions.some(item => {
        return !item.label || !item.condition;
      });

      if (hasEmptyFields) {
        this.$message.error('请完整填写过滤条件');
        return false;
      }
      return true;
    },

    // 验证批量修改字段是否填写完整
    validateBatchEditFields () {
      const hasEmptyFields = this.batchEditFields.some(item => {
        return !item.fieldName || !item.newValue;
      });

      if (hasEmptyFields) {
        this.$message.error('请完整填写修改内容');
        return false;
      }
      return true;
    },

    // 提交批量修改
    async submitBatchEdit () {
      try {
        // 验证所有字段是否都已填写
        const hasEmptyFields = this.batchEditFields.some(
          (field) => !field.fieldName || field.newValue === undefined || field.newValue === ''
        );

        if (hasEmptyFields) {
          this.$message.warning('请填写所有修改字段的值');
          return;
        }

        this.batchEditLoading = true;

        // 构造批量修改请求数据
        const specialFields = ['特征点', '附属物', '构筑物'];
        const modifyData = {
          ...this.filterResult,
          filterConditionsList: Array.from(
            this.batchEditFields
              .map((field) => {
                const baseField = {
                  attributeName: field.fieldName,
                  attributeValue:
                    Array.isArray(field.newValue) && field.newValue.length > 1
                      ? field.newValue[field.newValue.length - 1]
                      : field.newValue,
                };

                // 检查是否是特殊字段且有值
                if (specialFields.includes(field.fieldName) && field.newValue) {
                  // 创建其他特殊字段的空值条件
                  const otherFields = specialFields
                    .filter(name => name !== field.fieldName)
                    .map(name => ({
                      attributeName: name,
                      attributeValue: ''
                    }));

                  return [baseField, ...otherFields];
                }

                return [baseField];
              })
              .flat()
              .reduce((map, field) => {
                // 使用Map进行去重,如果attributeName已存在,保留最后一个值
                map.set(field.attributeName, field);
                return map;
              }, new Map())
              .values()
          )
        };

        if (this.tubesOrLines === 1 && this.connectivityNumber !== undefined) {
          modifyData.connectedNumbers = this.connectivityNumber;
        }

        const res = await this.$http.post('/gis-manager/diagramming/project/batch/modify', modifyData);

        if (res.code === 0) {
          this.$message.success('批量修改成功');
          this.handleBatchEditCancel();
          // 调用父组件的刷新方法
          this.$emit('refresh-map');
        } else {
          this.$message.error(res.message || '批量修改失败');
        }
      } catch (error) {
        console.error('批量修改失败:', error);
        this.$message.error('批量修改失败');
      } finally {
        this.batchEditLoading = false;
      }
    },
    refreshErrorDetailData () {
      this.showErrorDetailDialog = true;
      this.$emit('close-filter-detail'); // 通知父组件关闭过滤详情弹窗
      this.tabsType = '1';
      this.currentPointTab = 0;
      this.currentPipelineTab = 0;
      this.currentViewDetailId = null;
      this.handleDataCheck();
    }
  },
}
</script>

<style lang="less" scoped>
.toolbar {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  height: 48px;
  padding: 0 16px;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);

  .dropdown-container {
    position: relative;
    margin: 0 6px;

    .ant-btn {
      height: 32px;
      display: flex;
      align-items: center;
    }

    .dropdown-menu {
      position: absolute;
      top: 40px;
      left: 0;
      background-color: #fff;
      border-radius: 4px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      z-index: 1050;
      padding: 4px 0;
      opacity: 1;
      transition: opacity 0.3s;

      .dropdown-item {
        padding: 8px 12px;
        cursor: pointer;
        white-space: nowrap;

        &:hover {
          background-color: #f5f5f5;
        }
      }
    }
  }

  .ant-btn {
    display: flex;
    align-items: center;

    .anticon {
      font-size: 12px;
      margin-left: 4px;
    }
  }

  :deep(.export-modal) {
    display: flex;
    align-items: center;
    justify-content: center;

    .ant-modal {
      padding-bottom: 0;
      top: 0;

      &-content {
        box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08),
          0 9px 28px 8px rgba(0, 0, 0, 0.05);
      }
    }

    .ant-modal-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .filter-container {
    padding: 0 20px;

    .filter-section {
      margin-bottom: 24px;
      background: #fafafa;
      border-radius: 4px;
      padding: 16px;

      .section-title {
        font-size: 15px;
        font-weight: 500;
        color: #000000d9;
        margin-bottom: 16px;
        position: relative;
        padding-left: 10px;

        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 3px;
          height: 14px;
          background: #1890ff;
          border-radius: 2px;
        }
      }

      .section-content {
        padding: 0 8px;
      }

      .field-value-container {
        display: flex;
        align-items: center;
        gap: 8px;

        .action-wrapper {
          display: flex;
          align-items: center;
        }
      }
    }

    .condition-item {

      &:last-child {
        margin-bottom: 0;
      }
    }

    .action-column {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .action-icon {
      width: 20px;
      height: 20px;
      cursor: pointer;
      transition: opacity 0.3s;

      &:hover {
        opacity: 0.8;
      }
    }

    :deep(.ant-form-item) {
      margin-bottom: 12px;
      display: flex;
      align-items: center;

      .ant-form-item-control-wrapper {
        flex: 1;
      }
    }

    :deep(.ant-form-item-label) {
      text-align: right;
      padding-right: 12px;
      line-height: 32px;
      height: 32px;

      label {
        color: rgba(0, 0, 0, 0.85);
        height: 32px;
        line-height: 32px;
      }
    }

    :deep(.ant-radio-group) {
      display: flex;
      gap: 24px;
    }

    .field-value-container {
      display: flex;
      align-items: center;
      gap: 8px;

      .action-wrapper {
        display: flex;
        align-items: center;
      }

      :deep(.ant-select),
      :deep(.ant-input),
      :deep(.ant-input-number),
      :deep(.ant-calendar-picker) {
        width: 100%;
      }
    }
  }

  .selection-modal {
    :deep(.ant-modal-body) {
      padding: 24px;
    }
  }

  .batch-edit-container {
    margin-top: 16px;
    padding: 16px;
    background: #f8f8f8;
    border-radius: 4px;

    .section-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      padding-bottom: 12px;
      border-bottom: 1px solid #e8e8e8;

      .title-text {
        font-size: 14px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
      }

      .count-info {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.45);
      }
    }

    .filter-summary {
      margin-bottom: 16px;
      padding: 12px;
      background: #f0f7ff;
      border-radius: 4px;
      border-left: 4px solid #1890ff;

      .summary-label {
        font-weight: 500;
        margin-bottom: 8px;
      }

      .summary-content {
        color: rgba(0, 0, 0, 0.65);
        font-size: 12px;
        line-height: 1.5;
      }
    }

    .batch-edit-fields-wrapper {
      max-height: 300px;
      overflow-y: auto;
      margin: 0 -8px;
      padding: 0 8px;

      // 自定义滚动条样式
      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }

      &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
      }

      &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
      }
    }

    .batch-edit-fields {
      .edit-row {
        // margin-bottom: 16px;
        overflow-x: hidden;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .field-value-wrapper {
      display: flex;
      align-items: center;
      gap: 8px;

      .field-input {
        flex: 1;
      }

      .field-action {
        display: flex;
        align-items: center;
      }
    }

    .action-btn {
      padding: 4px;
      height: 32px;

      img {
        width: 16px;
        height: 16px;
      }

      &:hover {
        background-color: rgba(0, 0, 0, 0.04);
      }
    }

    .required {
      /deep/ .ant-form-item-label>label::before {
        display: inline-block;
        margin-right: 4px;
        color: #ff4d4f;
        font-size: 14px;
        font-family: SimSun, sans-serif;
        line-height: 1;
        content: '*';
      }
    }

    /deep/ .ant-form-item {
      margin-bottom: 0;

    }

    /deep/ .ant-form-item-label {
      line-height: 32px;
    }
  }

  .modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }

  .action-buttons {
    display: flex;
    align-items: center;
    height: 32px; // 调整操作按钮容器高度
    padding-top: 4px; // 微调顶部间距
  }

  .action-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  .filter-container-zd {
    display: flex;
    /* 启用flexbox布局 */
    align-items: center;
    /* 垂直方向上居中对齐 */
    padding-top: 4px;
  }

  .filter-item {
    /* 根据实际需求调整flex属性，例如flex-grow, flex-shrink, 或flex-basis */
    flex: 1;
    /* 使该元素占据剩余空间 */
    margin-right: 10px;
    display: flex;
    /* 启用flexbox布局 */
    align-items: center;
    /* 元素间的间距，可根据需要调整 */
  }

  // 统一所有表单控件的高度
  :deep(.ant-select),
  :deep(.ant-input),
  :deep(.ant-input-number),
  :deep(.ant-cascader-picker) {
    height: 32px;
    line-height: 32px;
  }

  .statistics-table {
    width: 100%;

    table {
      width: 100%;
      border-collapse: collapse;

      th,
      td {
        padding: 12px;
        text-align: center;
        border: 1px solid #e8e8e8;
      }

      th {
        background-color: #fafafa;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
      }

      tr:hover {
        background-color: #fafafa;
      }

      td:first-child {
        color: rgba(0, 0, 0, 0.65);
      }

      td:last-child {
        color: #1890ff;
        font-weight: 500;
      }
    }
  }

  .layout-content-div {
    background-color: white;
    padding: 5px;
    margin: 0 10px;
    display: flex;
    /* 使用 flex 布局 */
    align-items: center;
    /* 垂直居中对齐 */
    justify-content: space-between;
    /* 文字和图标左右分布 */
  }

  .icon-wrapper {
    margin-left: 8px;
    /* 图标与文字的间距 */
    color: #888;
    /* 图标颜色 */
  }


  .data-check-modal {
    /deep/ .ant-modal-content {
      border-radius: 8px;
      overflow: hidden;

      .ant-modal-header {
        padding: 16px 24px;
        background: #fafafa;
        border-bottom: 1px solid #f0f0f0;

        .ant-modal-title {
          font-size: 16px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
        }
      }

      .ant-modal-body {
        padding: 24px;

        .check-section {
          margin-bottom: 24px;
          display: flex;

          &:last-child {
            margin-bottom: 0;
          }

          .section-title {
            display: flex;
            align-items: center;
            margin-bottom: 16px;

            .title-bar {
              width: 4px;
              height: 16px;
              background: #1890ff;
              border-radius: 2px;
              margin-right: 8px;
            }

            span {
              font-size: 14px;
              font-weight: 500;
              color: rgba(0, 0, 0, 0.85);
            }
          }

          .section-content {
            padding-left: 12px;

            .horizontal-radio {
              display: flex;
              flex-wrap: wrap;
              gap: 16px;

              .ant-radio-wrapper {
                margin-right: 0;

                &:hover {
                  .ant-radio-inner {
                    border-color: #1890ff;
                  }
                }

                .ant-radio-checked {
                  .ant-radio-inner {
                    border-color: #1890ff;

                    &::after {
                      background-color: #1890ff;
                    }
                  }
                }

                &+.ant-radio-wrapper {
                  margin-left: 0;
                }
              }
            }
          }
        }
      }

      .ant-modal-footer {
        padding: 16px 24px;
        border-top: 1px solid #f0f0f0;

        .ant-btn {
          height: 32px;
          padding: 0 16px;
          border-radius: 4px;

          &+.ant-btn {
            margin-left: 8px;
          }
        }

        .ant-btn-primary {
          background: #1890ff;
          border-color: #1890ff;

          &:hover {
            background: #40a9ff;
            border-color: #40a9ff;
          }
        }
      }
    }
  }

  .error-section {
    margin-bottom: 24px;

    .error-type-title {
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 16px;
      color: rgba(0, 0, 0, 0.85);

      &:before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 16px;
        background: #1890ff;
        border-radius: 2px;
        margin-right: 8px;
        vertical-align: middle;
      }
    }
  }

  /deep/ .ant-drawer-body {
    padding: 0 !important;
    overflow: hidden;
  }

  /deep/ .ant-tabs {
    height: 100%;
  }

  /deep/ .ant-tabs-content {
    height: calc(100% - 56px);
    /* 减去标签页标题的高度 */
  }

  /deep/ .ant-tabs-tabpane {
    height: 100%;
    overflow: hidden;
    padding: 0 24px;
  }

  .custom-tabs {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .tab-header {
    display: flex;
    padding: 12px 0;
    border-bottom: 1px solid #f0f0f0;
    overflow-x: auto;
    flex-wrap: nowrap;

    .tab-item {
      padding: 8px 16px;
      cursor: pointer;
      margin-right: 16px;
      border-radius: 4px;
      transition: all 0.3s;
      white-space: nowrap;

      &:hover {
        background-color: #f5f5f5;
      }

      &.active {
        background-color: #e6f7ff;
        color: #1890ff;
      }

      .tab-text {
        margin-right: 8px;
      }

      .tab-badge {
        background-color: #f5f5f5;
        padding: 2px 8px;
        border-radius: 10px;
        font-size: 12px;
      }
    }
  }

  .refresh-button-container {
    display: flex;
    justify-content: flex-end;
    padding: 16px 0;
  }

  /deep/ .ant-table-wrapper {
    background: #fff;

    .ant-table-thead>tr>th {
      background-color: #fafafa;
      font-weight: 500;
    }

    .ant-table-placeholder {
      padding: 16px;
      text-align: center;

      .ant-empty-image {
        height: 40px;
      }

      .ant-empty-description {
        color: rgba(0, 0, 0, 0.45);
      }
    }

    .ant-table-row:hover {
      td {
        background-color: #e6f7ff;
      }
    }
  }

  /deep/ .error-stats {
    background: #f5f7fa;
    border-radius: 4px;
    padding: 12px 16px;
    margin-bottom: 16px;

    .stat-item {
      display: flex;
      align-items: center;

      .stat-label {
        margin-right: 8px;
        color: rgba(0, 0, 0, 0.65);
      }

      .stat-value {
        font-weight: 500;
        color: #1890ff;
      }
    }
  }

  .custom-tabs {
    .tab-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 0;
      border-bottom: 1px solid #f0f0f0;

      .tab-header-left {
        display: flex;
        flex: 1;
        overflow-x: auto;

        .tab-item {
          padding: 8px 16px;
          cursor: pointer;
          margin-right: 16px;
          border-radius: 4px;
          transition: all 0.3s;

          &:hover {
            background-color: #f5f5f5;
          }

          &.active {
            background-color: #e6f7ff;
            color: #1890ff;
          }

          .tab-text {
            margin-right: 8px;
          }

          .tab-badge {
            background-color: #f5f5f5;
            padding: 2px 8px;
            border-radius: 10px;
            font-size: 12px;
          }
        }
      }

      .tab-header-right {
        margin-left: 16px;
      }
    }

    .tab-content {
      background: #fff;
      border-radius: 4px;
      padding: 0;
    }
  }


  /deep/ .ant-form-item {
    margin-bottom: 12px; // 减小表单项底部间距 

  }

  // .edit-row {
  //   margin-bottom: 8px !important;  // 减小行间距
  // }

  .compact-form-item {
    margin-bottom: 0; // 移除表单项底部间距

    /deep/ .ant-form-item-label {
      line-height: 32px; // 调整标签行高
    }

    /deep/ .ant-form-item-control {
      line-height: 32px; // 调整控件行高
    }
  }

  .action-col {
    display: flex;
    align-items: center;
    padding-top: 30px !important; // 移除顶部padding
  }
}

.statistics-table {
  width: 100%;

  table {
    width: 100%;
    border-collapse: collapse;

    th,
    td {
      padding: 12px;
      text-align: center;
      border: 1px solid #e8e8e8;
    }

    th {
      background-color: #fafafa;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
    }

    tr:hover {
      background-color: #fafafa;
    }

    td:first-child {
      color: rgba(0, 0, 0, 0.65);
    }

    td:last-child {
      color: #1890ff;
      font-weight: 500;
    }
  }
}

.batch-edit-steps {
  display: flex;
  align-items: center;
  margin-bottom: 24px;

  .step-item {
    flex: 1;
    text-align: center;
    position: relative;

    &.active {
      font-weight: bold;
      color: #1890ff;

      // &::before {
      //   content: '';
      //   position: absolute;
      //   bottom: -16px;
      //   left: 50%;
      //   transform: translateX(-50%);
      //   width: 100%;
      //   height: 4px;
      //   background-color: #1890ff;
      //   border-radius: 2px;
      // }
    }

    .step-number {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      margin-bottom: 4px;
    }

    .step-title {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.65);
    }
  }

  .step-line {
    width: 100%;
    height: 4px;
    background-color: #f0f0f0;
    margin: 0 16px;

    &.active {
      background-color: #1890ff;
    }
  }
}

.field-value-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.field-input {
  flex: 1;
  margin-right: 16px;
}

.field-action {
  display: flex;
  align-items: center;
}

.action-btn {
  margin-left: 8px;
}

.danger-btn {
  color: #ff4d4f;
}

.toggle-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-left: 8px;
}



.filter-disabled {
  opacity: 0.5;
  pointer-events: none;
}

.batch-edit-modal {
  .ant-modal-body {
    padding: 24px;
  }

  .batch-edit-steps {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    padding: 0 16px;

    .step-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1;
      position: relative;

      .step-number {
        width: 28px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        background-color: #f5f5f5;
        border-radius: 50%;
        margin-bottom: 8px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.65);
        transition: all 0.3s;
      }

      .step-title {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        transition: all 0.3s;
      }

      &.active {
        .step-number {
          background-color: #1890ff;
          color: #fff;
        }

        .step-title {
          color: #1890ff;
          font-weight: 500;
        }
      }
    }

    .step-line {
      flex: 1;
      height: 2px;
      background-color: #f0f0f0;
      margin: 0 8px;
      margin-bottom: 30px;
      transition: all 0.3s;

      &.active {
        background-color: #1890ff;
      }
    }
  }

  .filter-section {
    margin-bottom: 24px;
    background: #fafafa;
    border-radius: 4px;
    padding: 16px;
    transition: all 0.3s;

    &:hover {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
    }

    .section-title {
      font-size: 15px;
      font-weight: 500;
      color: #000000d9;
      margin-bottom: 16px;
      position: relative;
      padding-left: 10px;
      display: flex;
      align-items: center;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 3px;
        height: 14px;
        background: #1890ff;
        border-radius: 2px;
      }
    }

    .condition-item {
      border-bottom: 1px dashed #f0f0f0;

      &:last-child {
        margin-bottom: 0;
        padding-bottom: 0;
        border-bottom: none;
      }
    }
  }

  .field-value-wrapper {
    display: flex;
    align-items: center;
    width: 100%;

    .field-input {
      flex: 1;
      display: flex;
      align-items: center;
    }

    .field-action {
      margin-left: 8px;
      display: flex;
      align-items: center;
    }
  }

  .toggle-btn {
    color: #1890ff;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0 8px;
    margin-left: 8px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;

    &:hover {
      color: #40a9ff;
    }

    &:active {
      color: #096dd9;
    }

    &[disabled] {
      color: rgba(0, 0, 0, 0.25);
      cursor: not-allowed;
    }
  }


  .filter-disabled {
    position: relative;

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(255, 255, 255, 0.4);
      pointer-events: none;
    }
  }

  .action-btn {
    height: 32px;
    width: 32px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    &.danger-btn {
      color: #ff4d4f;

      &:hover {
        color: #ff7875;
      }

      &:active {
        color: #d9363e;
      }
    }
  }

  .batch-edit-container {
    margin-top: 24px;
    border-top: 1px solid #f0f0f0;
    padding-top: 24px;

    .filter-summary {
      margin-bottom: 24px;
      padding: 16px;
      background: #f6f6f6;
      border-radius: 4px;
      border-left: 4px solid #1890ff;

      .summary-item {
        display: flex;
        align-items: baseline;
        margin-bottom: 12px;

        &:last-child {
          margin-bottom: 0;
        }

        .summary-label {
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
          min-width: 80px;
        }

        .summary-value {
          color: rgba(0, 0, 0, 0.65);

          &.highlight {
            color: #1890ff;
            font-size: 16px;
            font-weight: 500;
          }
        }
      }
    }

    .batch-edit-fields {
      max-height: 400px;
      min-height: 260px;
      overflow-y: auto;
      overflow-x: hidden;
      padding: 0 8px;
      margin: 16px 0;

      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }

      &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
      }

      .edit-row {
        position: relative;
        // padding: 12px;
        border: 1px solid #f0f0f0;
        border-radius: 4px;
        // margin-bottom: 12px;
        background: #fafafa;

        &:hover {
          border-color: #40a9ff;
          box-shadow: 0 0 4px rgba(24, 144, 255, 0.2);
        }
      }

      .action-buttons {
        display: flex;
        align-items: center;
        justify-content: center;

        .action-icon {
          width: 24px;
          height: 24px;
          cursor: pointer;
          margin: 0 4px;
          transition: all 0.3s;

          &:hover {
            transform: scale(1.1);
          }

          &.add-btn:hover {
            filter: brightness(1.2);
          }

          &.remove-btn:hover {
            filter: brightness(1.2);
          }
        }
      }
    }
  }

  .modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
}

.statistics-modal {
  :deep(.ant-modal-body) {
    max-height: 480px;
    overflow-y: auto;
  }
}

.statistics-container {
  padding: 0 16px;

  .statistics-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .header-title {
      font-size: 16px;
      font-weight: 500;
    }

    .view-switch {
      margin-left: auto;
    }
  }

  .statistics-content {
    background: #fff;
    border-radius: 4px;

    .statistics-section {
      margin-bottom: 24px;
      padding: 20px;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);

      &:last-child {
        margin-bottom: 0;
      }

      .section-header {
        margin-bottom: 20px;
        padding-bottom: 12px;
        border-bottom: 1px solid #f0f0f0;

        .section-title {
          position: relative;
          padding-left: 12px;
          font-size: 16px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);

          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 4px;
            height: 16px;
            background: #1890ff;
            border-radius: 2px;
          }
        }
      }

      .section-body {
        .statistics-grid {
          display: flex;
          grid-template-columns: repeat(2, 1fr);
          gap: 16px;
          text-align: center;

          .grid-item {
            padding: 16px;
            background: #fafafa;
            border-radius: 4px;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
            transition: all 0.3s;
            width: 20%;

            &:hover {
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
            }

            .item-label {
              font-size: 14px;
              color: rgba(0, 0, 0, 0.65);
              margin-bottom: 8px;
            }

            .item-value {
              font-size: 20px;
              font-weight: 500;
              color: #1890ff;
            }
          }
        }
      }
    }
  }
}

.charts-container {
  display: flex;
  flex-direction: column;
  gap: 24px;

  .statistics-chart {
    height: 280px;
    width: 100%;
  }
}

.statistics-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}

.empty-data {
  padding: 32px;
  text-align: center;
}

/* 数据查错详细列表样式 - 参考too.vue */
.ant-drawer-wrapper-body {
  .ant-drawer-body {
    padding: 24px;

    .error-check-title {
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 16px;
      color: rgba(0, 0, 0, 0.85);
    }

    .custom-tabs {
      margin-top: 16px;

      .tab-header {
        display: flex;
        background: #f5f7fa;
        border-radius: 4px 4px 0 0;
        overflow: hidden;

        .tab-item {
          padding: 12px 24px;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.3s;
          position: relative;

          &.active {
            background: #fff;
            color: #1890ff;
            font-weight: 500;

            &::after {
              content: '';
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              height: 2px;
              background: #1890ff;
            }
          }

          &:hover:not(.active) {
            color: #40a9ff;
          }
        }
      }

      .tab-content {
        background: #fff;
        padding: 16px;
        border-radius: 0 0 4px 4px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      }
    }

    .error-section {
      margin-top: 16px;

      .error-table-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;

        .title {
          font-size: 14px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
        }

        .actions {
          display: flex;
          gap: 8px;
        }
      }
    }
  }
}

/deep/ .ant-drawer-content-wrapper {
  .ant-table-wrapper {
    margin-bottom: 16px;
  }

  .ant-table-thead>tr>th {
    background: #fafafa;
    font-weight: 500;
    padding: 12px 16px;
  }

  .ant-table-tbody>tr>td {
    padding: 12px 16px;
  }

  .ant-table-row:hover {
    td {
      background: #e6f7ff;
    }
  }

  .ant-pagination {
    margin: 16px 0 8px;
  }
}

/* 创建管线选择集弹窗样式 */
/deep/ .selection-modal {
  .ant-modal-content {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

    .ant-modal-header {
      padding: 16px 24px;
      background: #fafafa;
      border-bottom: 1px solid #f0f0f0;

      .ant-modal-title {
        font-size: 16px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
      }
    }

    .ant-modal-body {
      padding: 24px;
    }

    .ant-modal-footer {
      padding: 10px 16px;
      border-top: 1px solid #f0f0f0;

      .ant-btn {
        height: 32px;
        padding: 0 16px;
        border-radius: 4px;
        font-weight: 500;

        &+.ant-btn {
          margin-left: 8px;
        }
      }

      .ant-btn-primary {
        background: #1890ff;
        border-color: #1890ff;

        &:hover {
          background: #40a9ff;
          border-color: #40a9ff;
        }
      }
    }
  }
}

.selection-modal {
  .ant-modal-body {
    padding: 24px;
  }

  .filter-section {
    margin-bottom: 24px;
    background: #fafafa;
    border-radius: 4px;
    padding: 16px;
    transition: all 0.3s;

    &:hover {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
    }

    .section-title {
      font-size: 15px;
      font-weight: 500;
      color: #000000d9;
      margin-bottom: 16px;
      position: relative;
      padding-left: 10px;
      display: flex;
      align-items: center;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 3px;
        height: 14px;
        background: #1890ff;
        border-radius: 2px;
      }
    }

    .section-content {
      .condition-item {
        border-bottom: 1px dashed #f0f0f0;

        &:last-child {
          margin-bottom: 0;
          padding-bottom: 0;
          border-bottom: none;
        }
      }
    }
  }

  .filter-container-zd {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .filter-item {
    flex: 1;
    display: flex;
    align-items: center;
  }

  .action-buttons {
    margin-left: 8px;
    display: flex;
    align-items: center;
  }

  .action-icon {
    width: 24px;
    height: 24px;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      opacity: 0.8;
    }
  }
}

.highlight-row {
  background-color: #1139eb !important;
  border-left: 3px solid #1890ff !important;
}

/deep/ .ant-form-item-control {
  line-height: 28px;
}

/deep/ .ant-select {
  line-height: 28px;
}

/deep/ .highlight-row {
  background-color: #e6f7ff !important;
  border-left: 3px solid #1890ff !important;
}

.refresh-button-container {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
}

.tab-content {
  padding: 16px 0;
  overflow: hidden;
}

.error-section {
  height: 670px;
  overflow: hidden;
}
</style>
